webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(411);
	module.exports = __webpack_require__(359);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gsap = __webpack_require__(62);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _actions = __webpack_require__(364);
	
	var _getters = __webpack_require__(77);
	
	var _Loader = __webpack_require__(147);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Container = __webpack_require__(74);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Row = __webpack_require__(351);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(348);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  ready: function ready() {
	    this.setTitle(this.title);
	    this.setTheme(this.theme);
	  },
	  data: function data() {
	    return {
	      enableTransition: true,
	      title: '',
	      theme: 'standard'
	    };
	  },
	
	  components: {
	    Container: _Container2.default,
	    Row: _Row2.default,
	    Column: _Column2.default,
	    Loader: _Loader2.default
	  },
	  vuex: {
	    actions: {
	      setTitle: _actions.setTitle,
	      setTheme: _actions.setTheme
	    },
	    getters: {
	      loading: _getters.loading
	    }
	  },
	  watch: {
	    title: function title() {
	      this.setTitle(this.title);
	    }
	  },
	  route: {
	    activate: function activate(transition) {
	      if (!this.enableTransition) {
	        transition.next();
	        return;
	      }
	
	      _gsap2.default.set(this.$el, { opacity: 0 });
	      _gsap2.default.to(this.$el, 0.5, { opacity: 1 });
	
	      transition.next();
	    },
	    deactivate: function deactivate(transition) {
	      if (!this.enableTransition) {
	        transition.next();
	        return;
	      }
	
	      _gsap2.default.to(this.$el, 0.5, { opacity: 0, onComplete: transition.next });
	    }
	  }
	};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.http = exports.PostSurvey = exports.PreSurvey = exports.Survey = exports.RefreshToken = exports.Sessions = exports.Teams = exports.Exercise = exports.SurveyTypes = exports.PredefinedExercises = exports.Exercises = exports.Logout = exports.Login = exports.host = undefined;
	
	var _vue = __webpack_require__(98);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(813);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _store = __webpack_require__(101);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var host = exports.host = window.location.hostname.search(/mindsocial/i) !== -1 ? 'mindsocial' : 'fuht';
	
	_vue2.default.http.options.root =  true ? 'https://api.' + host + '.dk/wp-json/pp/v1' : 'http://api.fuht.test/wp-json/pp/v1';
	_vue2.default.http.options.crossOrigin = true;
	_vue2.default.http.options.xhr = { withCredentials: true };
	
	_vue2.default.http.interceptors.push(function (request, next) {
	  var token = _store2.default._modules.auth.state.token;
	
	  if (token && !request.headers.Authorization) {
	    request.headers.Authorization = 'Bearer ' + token;
	  }
	
	  next(function (response) {
	    response.data = response.json();
	  });
	});
	
	var Login = exports.Login = _vue2.default.resource('auth');
	var Logout = exports.Logout = _vue2.default.resource('auth/invalidate');
	var Exercises = exports.Exercises = _vue2.default.resource('exercises');
	var PredefinedExercises = exports.PredefinedExercises = _vue2.default.resource('exercises/predefined');
	var SurveyTypes = exports.SurveyTypes = _vue2.default.resource('survey/types');
	var Exercise = exports.Exercise = _vue2.default.resource('exercises/{id}');
	var Teams = exports.Teams = _vue2.default.resource('me/teams');
	var Sessions = exports.Sessions = _vue2.default.resource('me/teams/{id}/sessions');
	var RefreshToken = exports.RefreshToken = _vue2.default.resource('auth/refresh');
	var Survey = exports.Survey = _vue2.default.resource('me/teams/{id}/survey/{type}');
	var PreSurvey = exports.PreSurvey = _vue2.default.resource('me/teams/{id}/survey/pre');
	var PostSurvey = exports.PostSurvey = _vue2.default.resource('me/teams/{id}/survey/post');
	var http = exports.http = _vue2.default.http;

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var IS_LOGGED_IN = exports.IS_LOGGED_IN = 'IS_LOGGED_IN';
	var SET_TOKEN = exports.SET_TOKEN = 'SET_TOKEN';
	var INVALIDATE_TOKEN = exports.INVALIDATE_TOKEN = 'INVALIDATE_TOKEN';
	
	var ASYNC_REQUEST = exports.ASYNC_REQUEST = 'ASYNC_REQUEST';
	var ASYNC_SUCCESS = exports.ASYNC_SUCCESS = 'ASYNC_SUCCESS';
	var ASYNC_FAILURE = exports.ASYNC_FAILURE = 'ASYNC_FAILURE';
	var ASYNC_CANCELLED = exports.ASYNC_CANCELLED = 'ASYNC_CANCELLED';
	var RECEIVE_EXERCISES = exports.RECEIVE_EXERCISES = 'RECEIVE_EXERCISES';
	var RECEIVE_TEAMS = exports.RECEIVE_TEAMS = 'RECEIVE_TEAMS';
	var ADD_TEAM = exports.ADD_TEAM = 'ADD_TEAM';
	var SET_ACTIVE_TEAM = exports.SET_ACTIVE_TEAM = 'SET_ACTIVE_TEAM';
	var RECEIVE_EXERCISE = exports.RECEIVE_EXERCISE = 'RECEIVE_EXERCISE';
	var SET_ACTIVE_EXERCISE = exports.SET_ACTIVE_EXERCISE = 'SET_ACTIVE_EXERCISE';
	var UPDATE_EXERCISE_INDEX = exports.UPDATE_EXERCISE_INDEX = 'UPDATE_EXERCISE_INDEX';
	var SET_TITLE = exports.SET_TITLE = 'SET_TITLE';
	var SET_THEME = exports.SET_THEME = 'SET_THEME';
	var SET_BACK_ROUTE = exports.SET_BACK_ROUTE = 'SET_BACK_ROUTE';
	var ADD_SESSION = exports.ADD_SESSION = 'ADD_SESSION';
	var DELETE_SESSION = exports.DELETE_SESSION = 'DELETE_SESSION';
	
	var SET_SURVEY_PRE = exports.SET_SURVEY_PRE = 'SET_SURVEY_PRE';
	var SET_SURVEY_POST = exports.SET_SURVEY_POST = 'SET_SURVEY_POST';
	var SET_SURVEY_SHARP_BRAINS = exports.SET_SURVEY_SHARP_BRAINS = 'SET_SURVEY_SHARP_BRAINS';

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(104);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(98);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _resources = __webpack_require__(18);
	
	var resources = _interopRequireWildcard(_resources);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getExercises: function getExercises() {
	    return resources.Exercises.get();
	  },
	  getExercise: function getExercise(id) {
	    return resources.Exercise.get({ id: id });
	  },
	  getTeams: function getTeams() {
	    return resources.Teams.get();
	  },
	  login: function login(username, password) {
	    var base64 = btoa(username + ':' + password);
	
	    return new _promise2.default(function (resolve, reject) {
	      _vue2.default.http.get('auth', {
	        headers: {
	          'Authorization': 'Basic ' + base64
	        }
	      }).then(function (response) {
	        if (!response.ok) {
	          reject(response);
	        }
	        resolve(response);
	      }).catch(function (response) {
	        reject(response);
	      });
	    });
	  },
	  getSurvey: function getSurvey(id) {
	    var pre = resources.Survey.get({ id: id, type: 'pre' });
	
	    var post = resources.Survey.get({ id: id, type: 'post' });
	
	    var sharpBrains = resources.Survey.get({ id: id, type: 'sharp_brains' });
	
	    return new _promise2.default(function (resolve, reject) {
	      _promise2.default.all([pre, post, sharpBrains]).then(function (responses) {
	        resolve({
	          pre: responses[0].data,
	          post: responses[1].data,
	          sharp_brains: responses[2].data
	        });
	      });
	    });
	  }
	};

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(693)
	__vue_script__ = __webpack_require__(372)
	__vue_template__ = __webpack_require__(754)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(708)
	__vue_script__ = __webpack_require__(379)
	__vue_template__ = __webpack_require__(769)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateIndex = exports.getExercise = exports.getAllExercises = undefined;
	
	var _promise = __webpack_require__(104);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _api = __webpack_require__(63);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _mutationTypes = __webpack_require__(35);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getAllExercises = exports.getAllExercises = function getAllExercises(_ref) {
	  var dispatch = _ref.dispatch,
	      state = _ref.state;
	
	  if (state.exercises.all.length === 0) {
	    dispatch(types.ASYNC_REQUEST);
	
	    _api2.default.getExercises().then(function (response) {
	      dispatch(types.RECEIVE_EXERCISES, response.data);
	      dispatch(types.ASYNC_SUCCESS);
	    });
	  }
	};
	
	var getExercise = exports.getExercise = function getExercise(_ref2, id) {
	  var dispatch = _ref2.dispatch,
	      state = _ref2.state;
	
	  return new _promise2.default(function (resolve) {
	    if (state.exercises.all.length === 0) {
	      dispatch(types.ASYNC_REQUEST);
	
	      _api2.default.getExercises().then(function (response) {
	        dispatch(types.RECEIVE_EXERCISES, response.data);
	        dispatch(types.ASYNC_SUCCESS);
	        dispatch(types.SET_ACTIVE_EXERCISE, id);
	        resolve();
	      });
	    } else {
	      dispatch(types.SET_ACTIVE_EXERCISE, id);
	      resolve();
	    }
	  });
	};
	
	var updateIndex = exports.updateIndex = function updateIndex(_ref3, oldIndex, newIndex) {
	  var dispatch = _ref3.dispatch,
	      state = _ref3.state;
	
	  dispatch(types.UPDATE_EXERCISE_INDEX, oldIndex, newIndex);
	};

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var title = exports.title = function title(state) {
	  return state.view.title;
	};
	var theme = exports.theme = function theme(state) {
	  return state.view.theme;
	};
	var loading = exports.loading = function loading(state) {
	  return state.view.isLoading;
	};
	var backRoute = exports.backRoute = function backRoute(state) {
	  return state.view.backRoute;
	};

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(714)
	__vue_script__ = __webpack_require__(382)
	__vue_template__ = __webpack_require__(775)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 98 */,
/* 99 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isLoggedIn = exports.isLoggedIn = function isLoggedIn(state) {
	  return state.auth.isLoggedIn;
	};
	var role = exports.role = function role(state) {
	  return state.auth.role;
	};
	var token = exports.token = function token(state) {
	  return state.auth.token;
	};

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var allExercises = exports.allExercises = function allExercises(state) {
	  return state.exercises.all;
	};
	var activeExercise = exports.activeExercise = function activeExercise(state) {
	  return state.exercises.active;
	};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(98);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(818);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _store = __webpack_require__(360);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _store3 = __webpack_require__(361);
	
	var _store4 = _interopRequireDefault(_store3);
	
	var _store5 = __webpack_require__(363);
	
	var _store6 = _interopRequireDefault(_store5);
	
	var _store7 = __webpack_require__(362);
	
	var _store8 = _interopRequireDefault(_store7);
	
	var _store9 = __webpack_require__(365);
	
	var _store10 = _interopRequireDefault(_store9);
	
	var _logger = __webpack_require__(819);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = ("production") !== 'production';
	
	_vue2.default.use(_vuex2.default);
	_vue2.default.config.debug = debug;
	
	exports.default = new _vuex2.default.Store({
	  modules: {
	    auth: _store2.default,
	    exercises: _store4.default,
	    teams: _store6.default,
	    survey: _store8.default,
	    view: _store10.default
	  },
	  strict: debug,
	  middlewares: debug ? [(0, _logger2.default)()] : []
	});

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setActiveTeam = exports.deleteSession = exports.addSession = exports.deleteTeam = exports.newTeam = exports.getAllTeams = undefined;
	
	var _api = __webpack_require__(63);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _resources = __webpack_require__(18);
	
	var _mutationTypes = __webpack_require__(35);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getAllTeams = exports.getAllTeams = function getAllTeams(_ref) {
	  var dispatch = _ref.dispatch,
	      state = _ref.state;
	
	  if (state.teams.all.length === 0) {
	    dispatch(types.ASYNC_REQUEST);
	    return _api2.default.getTeams().then(function (response) {
	      dispatch(types.RECEIVE_TEAMS, response.data);
	      dispatch(types.ASYNC_SUCCESS);
	    }).catch(function (error) {
	      console.log(error);
	      dispatch(types.ASYNC_FAILURE, error.data.code);
	    });
	  }
	};
	var newTeam = exports.newTeam = function newTeam(_ref2, team) {
	  var dispatch = _ref2.dispatch,
	      state = _ref2.state;
	
	  return _resources.Teams.save(team).then(function (response) {
	    return dispatch(types.ADD_TEAM, response.data);
	  });
	};
	
	var deleteTeam = exports.deleteTeam = function deleteTeam(_ref3, id) {
	  var dispatch = _ref3.dispatch,
	      state = _ref3.state;
	
	  return _resources.Teams.delete({ id: id });
	};
	
	var addSession = exports.addSession = function addSession(_ref4) {
	  var dispatch = _ref4.dispatch,
	      state = _ref4.state;
	  return dispatch(types.ADD_SESSION);
	};
	var deleteSession = exports.deleteSession = function deleteSession(_ref5, id) {
	  var dispatch = _ref5.dispatch,
	      state = _ref5.state;
	  return dispatch(types.DELETE_SESSION, id);
	};
	var setActiveTeam = exports.setActiveTeam = function setActiveTeam(_ref6, id) {
	  var dispatch = _ref6.dispatch,
	      state = _ref6.state;
	
	  if (state.teams.all.length === 0) {
	    dispatch(types.ASYNC_REQUEST);
	    _api2.default.getTeams().then(function (response) {
	      dispatch(types.RECEIVE_TEAMS, response.data);
	      dispatch(types.ASYNC_SUCCESS);
	      dispatch(types.SET_ACTIVE_TEAM, id);
	    });
	  } else {
	    dispatch(types.SET_ACTIVE_TEAM, id);
	  }
	};

/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(686)
	__vue_script__ = __webpack_require__(383)
	__vue_template__ = __webpack_require__(747)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(413);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _map = __webpack_require__(414);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _getters = __webpack_require__(100);
	
	var _actions = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  vuex: {
	    getters: {
	      allExercises: _getters.allExercises
	    },
	    actions: {
	      getAllExercises: _actions.getAllExercises
	    }
	  },
	  data: function data() {
	    return {
	      filter: null
	    };
	  },
	
	  computed: {
	    filters: function filters() {
	      var filters = new _map2.default();
	
	      this.allExercises.map(function (session) {
	        session.filters.forEach(function (filter) {
	          filters.set(filter, filter);
	        });
	      });
	      return (0, _from2.default)(filters);
	    },
	    sortedExercises: function sortedExercises() {
	      return this.allExercises.concat().sort(function (a, b) {
	        if (a.title < b.title) return -1;
	        if (a.title > b.title) return 1;
	        return 0;
	      });
	    },
	    filteredExercises: function filteredExercises() {
	      var _this = this;
	
	      if (!this.filter) return this.sortedExercises;
	      return this.sortedExercises.filter(function (exercise) {
	        return exercise.filters.indexOf(_this.filter) > -1;
	      });
	    }
	  },
	  methods: {
	    setFilter: function setFilter(filter) {
	      this.filter = filter;
	    }
	  },
	  ready: function ready() {
	    this.getAllExercises();
	  }
	};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.map = undefined;
	
	var _vue = __webpack_require__(98);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(814);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueValidator = __webpack_require__(816);
	
	var _vueValidator2 = _interopRequireDefault(_vueValidator);
	
	var _vueSortable = __webpack_require__(815);
	
	var _vueSortable2 = _interopRequireDefault(_vueSortable);
	
	var _vueAsyncComputed = __webpack_require__(736);
	
	var _vueAsyncComputed2 = _interopRequireDefault(_vueAsyncComputed);
	
	var _Login = __webpack_require__(803);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Dashboard = __webpack_require__(800);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _ExercisesView = __webpack_require__(802);
	
	var _ExercisesView2 = _interopRequireDefault(_ExercisesView);
	
	var _ExerciseView = __webpack_require__(801);
	
	var _ExerciseView2 = _interopRequireDefault(_ExerciseView);
	
	var _SubexerciseView = __webpack_require__(809);
	
	var _SubexerciseView2 = _interopRequireDefault(_SubexerciseView);
	
	var _Teams = __webpack_require__(812);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Team = __webpack_require__(811);
	
	var _Team2 = _interopRequireDefault(_Team);
	
	var _NewTeam = __webpack_require__(804);
	
	var _NewTeam2 = _interopRequireDefault(_NewTeam);
	
	var _Sessions = __webpack_require__(808);
	
	var _Sessions2 = _interopRequireDefault(_Sessions);
	
	var _Notes = __webpack_require__(805);
	
	var _Notes2 = _interopRequireDefault(_Notes);
	
	var _Participants = __webpack_require__(806);
	
	var _Participants2 = _interopRequireDefault(_Participants);
	
	var _Survey = __webpack_require__(810);
	
	var _Survey2 = _interopRequireDefault(_Survey);
	
	var _ResetPassword = __webpack_require__(807);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _jwtDecode = __webpack_require__(208);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _resources = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueValidator2.default);
	_vue2.default.use(_vueSortable2.default);
	_vue2.default.use(_vueAsyncComputed2.default);
	
	_vue2.default.validator('email', function (val) {
	  return (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val)
	  );
	});
	
	var router = new _vueRouter2.default({
	  history: true
	});
	
	var map = {
	  '/': {
	    name: 'root',
	    component: _Dashboard2.default
	  },
	  '/login': {
	    name: 'login',
	    component: _Login2.default
	  },
	  '/exercises': {
	    name: 'exercises',
	    component: _ExercisesView2.default
	  },
	  '/exercises/:id': {
	    name: 'exercise',
	    component: _ExerciseView2.default
	  },
	  '/exercises/:id/:subid': {
	    name: 'subexercise',
	    component: _SubexerciseView2.default
	  },
	  '/teams': {
	    name: 'teams',
	    component: _Teams2.default,
	    meta: { forbiddenRoles: ['facilitator'] }
	  },
	  '/teams/:team': {
	    name: 'team',
	    component: _Team2.default,
	    meta: { forbiddenRoles: ['facilitator'] }
	  },
	  'teams/:team/sessions': {
	    name: 'sessions',
	    component: _Sessions2.default,
	    meta: { forbiddenRoles: ['facilitator'] }
	  },
	  'teams/:team/notes': {
	    name: 'notes',
	    component: _Notes2.default,
	    meta: { forbiddenRoles: ['facilitator'] }
	  },
	  'teams/:team/participants': {
	    name: 'participants',
	    component: _Participants2.default,
	    meta: { forbiddenRoles: ['facilitator'] }
	  },
	  'teams/new': {
	    name: 'new-team',
	    component: _NewTeam2.default,
	    meta: { forbiddenRoles: ['facilitator'] }
	  },
	  'teams/:team/survey': {
	    name: 'survey',
	    component: _Survey2.default,
	    meta: { forbiddenRoles: ['facilitator'] }
	  },
	  'password/reset/:token': {
	    name: 'reset-password',
	    component: _ResetPassword2.default
	  }
	};
	
	router.map(map);
	
	router.beforeEach(function (_ref) {
	  var to = _ref.to,
	      next = _ref.next;
	
	  window.scrollTo(0, 0);
	  if (to.name === 'reset-password') {
	    next();
	    return;
	  }
	  var encodedToken = router.app.$store._modules.auth.state.token;
	  if (!encodedToken) {
	    console.log('%cNo token found', 'font-weight: bold; color: darkblue');
	
	    router.go({ name: 'login' });
	    next();
	    return;
	  }
	
	  if (typeof to.meta !== 'undefined' && typeof to.meta.forbiddenRoles !== 'undefined') {
	    var role = router.app.$store._modules.auth.state.role;
	    if (to.meta.forbiddenRoles.includes(role) || role === null) {
	      console.log('%cRoute forbidden for user role', 'font-weight: bold; color: red', role);
	      return false;
	    }
	  }
	
	  var token = (0, _jwtDecode2.default)(encodedToken);
	  var date = (0, _moment2.default)(token.exp * 1000);
	  var now = (0, _moment2.default)();
	
	  if (!date.isBefore(now)) {
	    console.log('%cToken is still valid', 'font-weight: bold; color: green');
	
	    if (to.name === 'login') {
	      router.go({ name: 'root' });
	    }
	    next();
	    return;
	  }
	
	  console.log('%cToken has expired', 'font-weight: bold; color: blue', token);
	
	  var isRefreshable = date.add(1, 'week').isAfter(now);
	  console.log('%cIs refreshable', 'font-weight: bold; color: blue', isRefreshable);
	
	  _resources.RefreshToken.get().then(function (response) {
	    var newToken = response.data.data.token;
	    console.log('%cOld token', 'font-weight: bold; color: grey', token);
	    console.log('%cNew token', 'font-weight: bold; color: black', (0, _jwtDecode2.default)(newToken));
	    router.app.$store.dispatch('SET_TOKEN', newToken);
	    next();
	  }).catch(function (response) {
	    console.log('%cToken could not be refreshed', 'font-weight: bold; color: red', response.body.message);
	    router.go({ name: 'login' });
	    next();
	  });
	});
	
	exports.default = router;
	exports.map = map;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setToken = exports.invalidateToken = exports.login = undefined;
	
	var _promise = __webpack_require__(104);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _api = __webpack_require__(63);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _resources = __webpack_require__(18);
	
	var _mutationTypes = __webpack_require__(35);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var login = exports.login = function login(_ref, username, password) {
	  var store = _ref.store,
	      dispatch = _ref.dispatch;
	
	  dispatch(types.ASYNC_REQUEST);
	
	  return _api2.default.login(username, password).then(function (response) {
	    console.log(response);
	    dispatch(types.SET_TOKEN, response.data.data.token);
	    dispatch(types.IS_LOGGED_IN);
	    dispatch(types.ASYNC_SUCCESS);
	  }).catch(function (response) {
	    console.log('error', username, password, response);
	    dispatch(types.ASYNC_FAILURE);
	  });
	};
	
	var invalidateToken = exports.invalidateToken = function invalidateToken(_ref2) {
	  var dispatch = _ref2.dispatch,
	      state = _ref2.state;
	
	  return new _promise2.default(function (resolve, reject) {
	    _resources.Logout.get().then(function (response) {
	      dispatch(types.INVALIDATE_TOKEN);
	      resolve(response);
	    });
	  });
	};
	
	var setToken = exports.setToken = function setToken(_ref3, token) {
	  var store = _ref3.store,
	      dispatch = _ref3.dispatch;
	
	  dispatch.types(types.SET_TOKEN, token);
	};

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var allTeams = exports.allTeams = function allTeams(state) {
	  return state.teams.all;
	};
	var sessions = exports.sessions = function sessions(state) {
	  return state.teams.sessions;
	};
	var activeTeam = exports.activeTeam = function activeTeam(state) {
	  return state.teams.active;
	};

/***/ }),
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(705)
	__vue_script__ = __webpack_require__(370)
	__vue_template__ = __webpack_require__(766)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(719)
	__vue_script__ = __webpack_require__(371)
	__vue_template__ = __webpack_require__(780)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(715)
	__vue_script__ = __webpack_require__(375)
	__vue_template__ = __webpack_require__(776)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(694)
	__vue_script__ = __webpack_require__(376)
	__vue_template__ = __webpack_require__(755)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(703)
	__vue_script__ = __webpack_require__(384)
	__vue_template__ = __webpack_require__(764)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(700)
	__vue_script__ = __webpack_require__(387)
	__vue_template__ = __webpack_require__(761)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(712)
	__vue_script__ = __webpack_require__(388)
	__vue_template__ = __webpack_require__(773)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(678)
	__vue_script__ = __webpack_require__(389)
	__vue_template__ = __webpack_require__(740)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(710)
	__vue_script__ = __webpack_require__(391)
	__vue_template__ = __webpack_require__(771)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 356 */,
/* 357 */,
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Container = __webpack_require__(74);
	
	Object.defineProperty(exports, 'Container', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Container).default;
	  }
	});
	
	var _Row = __webpack_require__(351);
	
	Object.defineProperty(exports, 'Row', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Row).default;
	  }
	});
	
	var _Column = __webpack_require__(348);
	
	Object.defineProperty(exports, 'Column', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Column).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _App = __webpack_require__(781);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(101);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(149);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _vuexRouterSync = __webpack_require__(817);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _vuexRouterSync.sync)(_store2.default, _router2.default);
	
	_router2.default.start(_App2.default, '#app');

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(40);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(35);
	
	var _jwtDecode = __webpack_require__(208);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var token = localStorage.getItem('token');
	var state = {
	  isLoggedIn: false,
	  token: token,
	  role: token !== null ? (0, _jwtDecode2.default)(token).role : null
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_TOKEN, function (state, token) {
	  localStorage.setItem('token', token);
	  state.token = token;
	  state.role = token !== null ? (0, _jwtDecode2.default)(token).role : null;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.INVALIDATE_TOKEN, function (state, token) {
	  localStorage.removeItem('token');
	  state.isLoggedIn = false;
	  state.token = null;
	  state.role = null;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.IS_LOGGED_IN, function (state) {
	  state.isLoggedIn = true;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(40);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  all: [],
	  active: {}
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.RECEIVE_EXERCISES, function (state, exercises) {
	  exercises.forEach(function (exercise, index) {
	    exercises[index].order = index;
	  });
	  state.all = exercises;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_ACTIVE_EXERCISE, function (state, id) {
	  state.active = state.all.find(function (exercise) {
	    return exercise.id === parseInt(id);
	  });
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_EXERCISE_INDEX, function (state, oldIndex, newIndex) {
	  state.all.splice(newIndex, 0, state.all.splice(oldIndex, 1)[0]);
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(40);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  pre: [],
	  post: []
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_SURVEY_PRE, function (state, survey) {
	  state.pre = survey;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_SURVEY_POST, function (state, survey) {
	  state.post = survey;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(40);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  all: [],
	  active: {},
	  sessions: []
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.RECEIVE_TEAMS, function (state, teams) {
	  state.all = teams;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.ADD_SESSION, function (state) {
	  state.sessions.push({
	    id: 4,
	    exercises: []
	  });
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.DELETE_SESSION, function (state, id) {
	  console.log(id);
	  state.sessions.splice(id, 1);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.ADD_TEAM, function (state, team) {
	  console.log('team', team);
	  if (state.all.length > 0) {
	    state.all.unshift(team.data);
	  }
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_ACTIVE_TEAM, function (state, id) {
	  var active = state.all.find(function (team) {
	    return team.id === parseInt(id);
	  });
	  state.active = active;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTheme = exports.setTitle = undefined;
	
	var _mutationTypes = __webpack_require__(35);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var setTitle = exports.setTitle = function setTitle(_ref, title) {
	  var store = _ref.store,
	      dispatch = _ref.dispatch;
	
	  dispatch(types.SET_TITLE, title);
	};
	
	var setTheme = exports.setTheme = function setTheme(_ref2, theme) {
	  var store = _ref2.store,
	      dispatch = _ref2.dispatch;
	
	  dispatch(types.SET_THEME, theme);
	};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(40);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  title: '',
	  isLoading: false,
	  backRoute: {
	    name: 'root'
	  },
	  theme: 'standard'
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_TITLE, function (state, title) {
	  state.title = title;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_THEME, function (state, theme) {
	  document.body.classList.remove('theme-' + state.theme);
	  state.theme = theme;
	  document.body.classList.add('theme-' + state.theme);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_BACK_ROUTE, function (state, name) {
	  state.backRoute.name = name;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.ASYNC_REQUEST, function (state) {
	  state.isLoading = true;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.ASYNC_SUCCESS, function (state) {
	  state.isLoading = false;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.ASYNC_FAILURE, function (state, error) {
	  state.isLoading = false;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(101);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Top = __webpack_require__(795);
	
	var _Top2 = _interopRequireDefault(_Top);
	
	var _View = __webpack_require__(797);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _Grid = __webpack_require__(788);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Symbols = __webpack_require__(793);
	
	var _Symbols2 = _interopRequireDefault(_Symbols);
	
	var _getters = __webpack_require__(77);
	
	var _resources = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      columns: 24
	    };
	  },
	
	  components: {
	    Grid: _Grid2.default,
	    Symbols: _Symbols2.default,
	    View: _View2.default,
	    Top: _Top2.default
	  },
	  store: _store2.default,
	  vuex: {
	    getters: {
	      title: _getters.title
	    }
	  },
	  created: function created() {
	    document.title = _resources.host === 'mindsocial' ? 'MindSocial App' : 'Fuht App';
	  }
	};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _md = __webpack_require__(724);
	
	var _md2 = _interopRequireDefault(_md);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    size: { default: '200', type: String },
	    email: { default: '', type: String } },
	  computed: {
	    style: function style() {
	      return {
	        width: this.size + 'px',
	        height: this.size + 'px'
	      };
	    },
	    src: function src() {
	      return '//www.gravatar.com/avatar/' + (0, _md2.default)(this.email) + '?s=' + this.size;
	    }
	  }
	};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Axis = __webpack_require__(666);
	
	var axis = _interopRequireWildcard(_d3Axis);
	
	var _d3Selection = __webpack_require__(672);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  name: 'Axis',
	  props: {
	    orientation: {
	      type: String,
	      default: 'bottom'
	    },
	    scale: {
	      type: Function,
	      default: function _default() {
	        return function () {};
	      }
	    },
	    ticks: {
	      type: Number,
	      default: 5
	    },
	    offsetX: {
	      type: Number,
	      default: 0
	    },
	    offsetY: {
	      type: Number,
	      default: 0
	    },
	    tickSizeInner: {
	      type: [Number],
	      default: 6
	    },
	    tickFormat: Function,
	    opacity: {
	      type: Number,
	      default: 1
	    },
	    paddedIndex: Boolean
	  },
	  computed: {
	    self: function self() {
	      return this.axis;
	    },
	    el: function el() {
	      return (0, _d3Selection.select)(this.$el);
	    },
	    type: function type() {
	      return 'axis' + this.orientation.charAt(0).toUpperCase() + this.orientation.slice(1).toLowerCase();
	    },
	    classes: function classes() {
	      return 'axis-' + this.orientation;
	    },
	    style: function style() {
	      return {
	        opacity: this.opacity
	      };
	    },
	    transform: function transform() {
	      return 'translate(' + this.offsetX + ', ' + this.offsetY + ')';
	    }
	  },
	  watch: {
	    'ticks': 'draw',
	    'scale': 'draw',
	    'tickSizeInner': 'draw'
	  },
	  methods: {
	    draw: function draw() {
	      this.axis = axis[this.type](this.scale);
	      this.axis.ticks(this.ticks);
	      this.axis.tickSizeInner(this.tickSizeInner);
	      if (this.paddedIndex) this.axis.tickFormat(function (d) {
	        return d + 1;
	      });
	
	      this.el.call(this.axis);
	    }
	  },
	  ready: function ready() {
	    this.draw();
	  }
	};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gsap = __webpack_require__(62);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _Symbol2 = __webpack_require__(354);
	
	var _Symbol3 = _interopRequireDefault(_Symbol2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BackButton',
	  components: {
	    Symbol: _Symbol3.default
	  },
	  transitions: {
	    reveal: {
	      enter: function enter(el, done) {
	        _gsap2.default.set(this.$el, { opacity: 0, x: 10 });
	        _gsap2.default.to(el, 0.5, { opacity: 1, x: 0, onComplete: done });
	      },
	      leave: function leave(el, done) {
	        _gsap2.default.to(el, 0.5, { x: 10, opacity: 0, onComplete: done });
	      }
	    }
	  }
	};

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Bar',
	  props: {
	    size: Number,
	    scala: {
	      type: Number,
	      default: 5
	    },
	    faded: Boolean
	  },
	  computed: {
	    style: function style() {
	      return {
	        width: this.size / this.scala * 100 + '%'
	      };
	    },
	    classes: function classes() {
	      return {
	        'color-tint': !this.faded,
	        'faded': this.faded
	      };
	    }
	  }
	};

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Column',
	  props: {
	    type: {
	      type: String,
	      default: ''
	    },
	    size: {
	      type: Number,
	      default: 12
	    },
	    sizes: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    offset: {
	      type: Number,
	      default: 0
	    },
	    breakpoints: {
	      type: Array,
	      default: function _default() {
	        return ['xs', 'sm', 'md', 'lg'];
	      }
	    }
	  },
	  computed: {
	    classes: function classes() {
	      return 'col-md-' + this.size;
	    }
	  }
	};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(40);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Container',
	  props: {
	    align: String
	  },
	  computed: {
	    classes: function classes() {
	      return (0, _defineProperty3.default)({}, 'align-' + this.align, this.align);
	    }
	  }
	};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(40);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Difficulties',
	  props: {
	    difficulties: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  methods: {
	    getMeterClasses: function getMeterClasses(difficulty) {
	      var _ref;
	
	      return _ref = {}, (0, _defineProperty3.default)(_ref, 'color-' + difficulty.color, difficulty.color), (0, _defineProperty3.default)(_ref, 'meter-half', difficulty.difficulty === 'half'), _ref;
	    }
	  },
	  computed: {
	    sortedDifficulties: function sortedDifficulties() {
	      var difficulties = [];
	      for (var key in this.difficulties) {
	        var name = key;
	        switch (name) {
	          case 'body':
	            name = 'Krop';
	            break;
	          case 'brain':
	            name = 'Hjerne';
	            break;
	          case 'demographics':
	            name = 'Omverden';
	            break;
	        }
	        difficulties.push({
	          name: name,
	          color: this.difficulties[key].color,
	          difficulty: this.difficulties[key].difficulty > 0.5 ? 'full' : 'half'
	        });
	      }
	      return difficulties;
	    }
	  }
	};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gsap = __webpack_require__(62);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    index: {
	      type: Number,
	      default: 0
	    },
	    id: {
	      type: Number,
	      default: 0
	    },
	    title: {
	      type: String,
	      default: ''
	    },
	    description: {
	      type: String,
	      default: ''
	    },
	    subexercises: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    delay: {
	      type: Number,
	      default: 0.2
	    },
	    y: {
	      type: Number,
	      default: -30
	    },
	    duration: {
	      type: Number,
	      default: 0.5
	    }
	  },
	  transitions: {
	    reveal: {
	      enter: function enter(el, done) {
	        _gsap2.default.set(this.$el, { opacity: 0, y: this.y });
	        _gsap2.default.to(el, this.duration, { opacity: 1, y: 0, onComplete: done, delay: this.delay * this.index });
	      }
	    }
	  }
	};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(723);
	
	exports.default = {
	  name: 'Filters',
	  data: function data() {
	    return {
	      filter: null,
	
	      priorityFilters: ['Intro', 'Øjentræningøvelser', 'Individuelle øvelser', 'Parøvelser', 'Gruppeøvelser', 'Outro']
	    };
	  },
	
	  props: {
	    filters: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  methods: {
	    setFilter: function setFilter(filter) {
	      this.filter = filter;
	      this.$emit('filter', filter);
	    }
	  },
	  computed: {
	    computedFilters: function computedFilters() {
	      return this.filters.map(function (filter) {
	        return filter[0];
	      });
	    },
	    sortedFilters: function sortedFilters() {
	      var _this = this;
	
	      return (0, _lodash.union)(this.priorityFilters, this.computedFilters).filter(function (item) {
	        return _this.computedFilters.includes(item);
	      });
	    }
	  }
	};

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'FlipButton',
	  data: function data() {
	    return {
	      directions: [],
	      isOpen: false,
	      direction: undefined
	    };
	  },
	
	  props: {
	    onConfirm: {
	      type: Function,
	      default: function _default() {
	        return function () {};
	      }
	    }
	  },
	  computed: {
	    width: function width() {
	      return this.$el.offsetWidth;
	    },
	    height: function height() {
	      return this.$el.offsetHeight;
	    },
	    offset: function offset() {
	      return { left: this.$el.offsetLeft, top: this.$el.offsetTop };
	    },
	    buttonClass: function buttonClass() {
	      return this.isOpen ? 'is-open' : '';
	    }
	  },
	  methods: {
	    click: function click(event) {
	      var _this = this;
	
	      var mx = event.clientX - this.offset.left;
	      var my = event.clientY - this.offset.top;
	
	      var w = this.width;
	      var h = this.height;
	
	      this.directions = [{ id: 'top', x: w / 2, y: 0 }, { id: 'right', x: w, y: h / 2 }, { id: 'bottom', x: w / 2, y: h }, { id: 'left', x: 0, y: h / 2 }];
	
	      this.directions.sort(function (a, b) {
	        _this.distance(mx, my, a.x, a.y) - _this.distance(mx, my, b.x, b.y);
	      });
	
	      this.direction = this.directions.shift().id;
	
	      this.isOpen = true;
	    },
	    confirm: function confirm() {
	      this.hide();
	      this.onConfirm();
	    },
	    hide: function hide() {
	      this.isOpen = false;
	    },
	    distance: function distance(x1, y1, x2, y2) {
	      var dx = x1 - x2;
	      var dy = y1 - y2;
	      return Math.sqrt(dx * dx + dy * dy);
	    }
	  }
	};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__(671);
	
	var _Axis = __webpack_require__(783);
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	var _Line = __webpack_require__(790);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Graph',
	  components: {
	    Axis: _Axis2.default, Line: _Line2.default
	  },
	  props: {
	    height: {
	      type: Number,
	      default: 600
	    },
	    pre: {
	      type: [Array, Boolean],
	      default: function _default() {
	        return [];
	      }
	    },
	    post: {
	      type: [Array, Boolean],
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      width: 750
	    };
	  },
	
	  computed: {
	    scaleX: function scaleX() {
	      return (0, _d3Scale.scaleLinear)().domain([0, this.max - 1]).range([0, this.width]);
	    },
	    intWidth: function intWidth() {
	      return parseInt(this.width);
	    },
	    max: function max() {
	      return this.pre.length > this.post.length ? this.pre.length : this.post.length;
	    },
	    scaleY: function scaleY() {
	      return (0, _d3Scale.scaleLinear)().domain([5, 1]).range([0, this.height]);
	    }
	  },
	  methods: {
	    resize: function resize() {
	      this.width = this.$el.getBoundingClientRect().width;
	      console.log('this.width', this.width);
	    }
	  },
	  ready: function ready() {
	    var _this = this;
	
	    window.addEventListener('resize', this.resize);
	    setTimeout(function () {
	      return _this.resize();
	    }, 500);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.resize);
	  }
	};

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    columns: {
	      default: 12,
	      type: Number
	    }
	  }
	};

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'HeaderGroup',
	  props: {
	    heading: {
	      type: String,
	      default: 'Heading'
	    },
	    heading2: {
	      type: String
	    },
	    subheading: {
	      type: String
	    }
	  }
	};

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'InputGroup',
	  props: {
	    type: {
	      type: String,
	      default: 'text'
	    },
	    label: {
	      type: String,
	      default: ''
	    },
	    placeholder: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Shape = __webpack_require__(673);
	
	var shape = _interopRequireWildcard(_d3Shape);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  name: 'Line',
	  props: {
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    strokeWidth: {
	      type: Number,
	      default: 2
	    },
	    stroke: {
	      type: String,
	      default: 'currentcolor'
	    },
	    scaleX: {
	      type: Function,
	      default: function _default() {
	        return function () {};
	      }
	    },
	    scaleY: {
	      type: Function,
	      default: function _default() {
	        return function () {};
	      }
	    },
	    keyX: {
	      type: String,
	      default: 'x'
	    },
	    keyY: {
	      type: String,
	      default: 'y'
	    }
	  },
	  computed: {
	    set: function set() {
	      var _this = this;
	
	      return shape.line().x(function (d, i) {
	        return _this.scaleX(i);
	      }).y(function (d) {
	        return _this.scaleY(d[_this.keyY]);
	      });
	    }
	  }
	};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gsap = __webpack_require__(62);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    index: {
	      type: Number,
	      default: 0
	    },
	    order: {
	      type: Number,
	      default: 0
	    },
	    delay: {
	      type: Number,
	      default: 0.2
	    },
	    y: {
	      type: Number,
	      default: -30
	    },
	    duration: {
	      type: Number,
	      default: 0.5
	    },
	    link: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    size: {
	      type: [Boolean, String]
	    }
	  },
	  computed: {
	    formattedIndex: function formattedIndex() {
	      return this.pad(this.index + 1, 2);
	    },
	    classes: function classes() {
	      return 'size-' + this.size;
	    }
	  },
	  methods: {
	    pad: function pad(number, digits) {
	      return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number;
	    }
	  },
	  transitions: {
	    reveal: {
	      enter: function enter(el, done) {
	        _gsap2.default.set(this.$el, { opacity: 0, y: this.y });
	        _gsap2.default.to(el, this.duration, { opacity: 1, y: 0, onComplete: function onComplete() {
	            el.style.opacity = '';
	            done();
	          }, delay: this.delay * this.index });
	      }
	    }
	  }
	};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gsap = __webpack_require__(62);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _Sprite = __webpack_require__(352);
	
	var _Sprite2 = _interopRequireDefault(_Sprite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Loader',
	  components: {
	    Sprite: _Sprite2.default
	  },
	  data: function data() {
	    return {
	      loaded: false,
	      images: [__webpack_require__(734)]
	    };
	  },
	
	  transitions: {
	    loader: {
	      enter: function enter(el, done) {
	        this.loaded = false;
	
	        _gsap2.default.to(el, 0.5, { opacity: 1, onComplete: done });
	      },
	      leave: function leave(el, done) {
	        this.loaded = true;
	        _gsap2.default.to(el, 0.5, { opacity: 0, delay: 0.1, onComplete: function onComplete() {
	            done();
	          } });
	      }
	    }
	  },
	  computed: {
	    classes: function classes() {
	      return this.loaded ? '' : 'load';
	    }
	  }
	};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(40);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Row',
	  props: {
	    alignItems: {
	      type: String,
	      default: undefined
	    },
	    justifyContent: {
	      type: String,
	      default: undefined
	    },
	    fullHeight: {
	      type: [Boolean, String],
	      default: false
	    }
	  },
	  computed: {
	    classes: function classes() {
	      var _ref;
	
	      return _ref = {}, (0, _defineProperty3.default)(_ref, 'align-items-' + this.alignItems, this.alignItems), (0, _defineProperty3.default)(_ref, 'justify-content-' + this.justifyContent, this.justifyContent), (0, _defineProperty3.default)(_ref, 'full-height', this.fullHeight && this.fullHeight !== 'force'), (0, _defineProperty3.default)(_ref, 'full-height-force', this.fullHeight && this.fullHeight === 'force'), _ref;
	    }
	  }
	};

/***/ }),
/* 385 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'SmallHeading',
	  props: {
	    text: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gsap = __webpack_require__(62);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _stupidSprite = __webpack_require__(345);
	
	var _stupidSprite2 = _interopRequireDefault(_stupidSprite);
	
	var _stupidTick = __webpack_require__(346);
	
	var _stupidTick2 = _interopRequireDefault(_stupidTick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SmallLogo',
	  data: function data() {
	    return {
	      isHovered: false,
	      endFrame: undefined,
	      tick: undefined,
	      sprite: undefined
	    };
	  },
	
	  computed: {
	    canvas: function canvas() {
	      return this.$el.querySelector('canvas');
	    }
	  },
	  props: {
	    images: {
	      type: Array,
	      required: true,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  ready: function ready() {
	    this.tick = (0, _stupidTick2.default)({ fps: 25 });
	
	    this.sprite = (0, _stupidSprite2.default)({
	      tick: this.tick,
	      canvas: this.canvas,
	      loop: false
	    });
	
	    this.sprite.load(this.images).success(this.success);
	
	    this.sprite.on('ended', this.ended);
	  },
	
	  methods: {
	    success: function success() {
	      this.endFrame = this.sprite.getEndFrame();
	      this.sprite.reverse(true);
	      this.sprite.play(this.endFrame);
	    },
	    ended: function ended() {
	      if (this.isHovered && this.sprite.getFrame() === '0') {
	        this.mouseOver();
	      } else if (!this.isHovered && this.sprite.getFrame() === this.endFrame) {
	        this.mouseLeave();
	      }
	    },
	    mouseOver: function mouseOver() {
	      this.isHovered = true;
	      if (!this.sprite.hasLoaded() || this.sprite.isPlaying()) return;
	      this.sprite.reverse(false);
	      this.sprite.play();
	    },
	    mouseLeave: function mouseLeave() {
	      this.isHovered = false;
	      if (this.sprite.isPlaying()) return;
	      this.sprite.reverse(true);
	      this.sprite.play();
	    }
	  },
	  transitions: {
	    logo: {
	      enter: function enter(el, done) {
	        var _this = this;
	
	        _gsap2.default.to(this.$el, 0.5, { x: 0, opacity: 1, onComplete: function onComplete() {
	            _this.mouseLeave();
	            done();
	          } });
	      },
	      leave: function leave(el, done) {
	        this.mouseOver();
	        _gsap2.default.to(this.$el, 0.5, { x: -44, opacity: 0, onComplete: done });
	      }
	    }
	  }
	};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stupidSprite = __webpack_require__(345);
	
	var _stupidSprite2 = _interopRequireDefault(_stupidSprite);
	
	var _stupidTick = __webpack_require__(346);
	
	var _stupidTick2 = _interopRequireDefault(_stupidTick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Sprite',
	  data: function data() {
	    return {
	      isHovered: false,
	      endFrame: undefined,
	      tick: undefined,
	      sprite: undefined
	    };
	  },
	
	  props: {
	    images: {
	      type: Array,
	      required: true,
	      default: function _default() {
	        return [];
	      }
	    },
	    playing: {
	      type: Boolean,
	      default: true
	    }
	  },
	  ready: function ready() {
	    this.tick = (0, _stupidTick2.default)({ fps: 25 });
	
	    this.sprite = (0, _stupidSprite2.default)({
	      tick: this.tick,
	      canvas: this.$els.canvas,
	      loop: true
	    });
	
	    this.sprite.load(this.images).success(this.success);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.tick = null;
	    this.sprite = null;
	  },
	
	  methods: {
	    success: function success() {
	      this.endFrame = this.sprite.getEndFrame();
	      this.sprite.play(0);
	    }
	  },
	  watch: {
	    playing: function playing() {
	      !this.playing ? this.sprite.pause() : this.sprite.play();
	    }
	  }
	};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Difficulties = __webpack_require__(785);
	
	var _Difficulties2 = _interopRequireDefault(_Difficulties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Difficulties: _Difficulties2.default
	  },
	  props: {
	    exercise: Object,
	    index: Number
	  }
	};

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    name: '',
	    className: {
	      default: 'component-symbol',
	      type: String
	    }
	  },
	  computed: {
	    id: function id() {
	      return '#' + this.name;
	    },
	    classes: function classes() {
	      return this.className + ' ' + this.className + '-' + this.name;
	    }
	  }
	};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sprite = __webpack_require__(732);
	
	var _sprite2 = _interopRequireDefault(_sprite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  template: '<div class="component-symbols">' + _sprite2.default + '</div>'
	};

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'TableData',
	  props: {
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    columns: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    filterKey: String
	  },
	  data: function data() {
	    var sortOrders = {};
	    this.columns.forEach(function (key) {
	      sortOrders[key] = 1;
	    });
	    return {
	      sortKey: '',
	      sortOrders: sortOrders
	    };
	  },
	
	  methods: {
	    sortBy: function sortBy(key) {
	      this.sortKey = key;
	      this.sortOrders[key] = this.sortOrders[key] * -1;
	    },
	    isFunction: function isFunction(test) {
	      return typeof test === 'function';
	    },
	    onClick: function onClick(index) {
	      this.$emit('remove', index);
	    }
	  }
	};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _markdown = __webpack_require__(416);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	var _codemirror = __webpack_require__(78);
	
	var _codemirror2 = _interopRequireDefault(_codemirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_markdown2.default;
	
	exports.default = {
	  name: 'Text',
	  props: {
	    initialText: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      model: {
	        text: this.initialText,
	        stats: {
	          words: 0,
	          chars: 0
	        }
	      },
	      editor: null
	    };
	  },
	
	  computed: {
	    words: function words() {
	      return this.model.text.split(' ').length - 1;
	    },
	    chars: function chars() {
	      return this.model.text.length;
	    },
	    lastChar: function lastChar() {
	      return this.model.text[this.model.text.length - 1];
	    },
	    textarea: function textarea() {
	      return this.$el.querySelector('textarea');
	    }
	  },
	  methods: {
	    onChange: function onChange() {
	      var text = this.editor.getValue();
	      this.$emit('value', text);
	      this.model.text = text;
	    }
	  },
	  ready: function ready() {
	    this.editor = _codemirror2.default.fromTextArea(this.textarea, {
	      mode: 'markdown',
	      lineNumbers: false,
	      lineWrapping: true,
	      autofocus: true,
	      theme: 'default',
	      extraKeys: { 'Enter': 'newlineAndIndentContinueMarkdownList' }
	    });
	    this.editor.on('change', this.onChange);
	    this.editor.setValue(this.initialText);
	  }
	};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Symbol2 = __webpack_require__(354);
	
	var _Symbol3 = _interopRequireDefault(_Symbol2);
	
	var _SmallLogo = __webpack_require__(792);
	
	var _SmallLogo2 = _interopRequireDefault(_SmallLogo);
	
	var _BackButton = __webpack_require__(784);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _SmallHeading = __webpack_require__(791);
	
	var _SmallHeading2 = _interopRequireDefault(_SmallHeading);
	
	var _Avatar = __webpack_require__(782);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _getters = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    title: {
	      type: String,
	      default: ''
	    },
	    email: {
	      type: String,
	      default: 'jakobhenner@gmail.com'
	    }
	  },
	  computed: {
	    isRoot: function isRoot() {
	      return this.$route.name === 'root' || this.$route.name === 'login';
	    }
	  },
	  components: {
	    Symbol: _Symbol3.default,
	    Logo: _SmallLogo2.default,
	    BackButton: _BackButton2.default,
	    SmallHeading: _SmallHeading2.default,
	    Avatar: _Avatar2.default
	  },
	  methods: {
	    checkRoute: function checkRoute() {},
	    back: function back() {
	      this.$route.router.go(window.history.back());
	    }
	  },
	  watch: {
	    '$route': 'checkRoute'
	  },
	  vuex: {
	    getters: {
	      backRoute: _getters.backRoute
	    }
	  },
	  ready: function ready() {
	    this.checkRoute();
	  }
	};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Bar = __webpack_require__(347);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'VerticalGraph',
	  components: {
	    Bar: _Bar2.default
	  },
	  props: {
	    pre: {
	      type: Array,
	      required: true
	    },
	    post: {
	      type: Array,
	      required: false
	    }
	  },
	  computed: {
	    questionsSource: function questionsSource() {
	      if (this.pre.length > 0) {
	        return this.pre;
	      } else {
	        return this.post;
	      }
	    }
	  }
	};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Loader = __webpack_require__(147);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _getters = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Loader: _Loader2.default
	  },
	  vuex: {
	    getters: {
	      loading: _getters.loading
	    }
	  }
	};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(103);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _player = __webpack_require__(357);
	
	var _player2 = _interopRequireDefault(_player);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pid = 0;
	
	exports.default = {
	  props: {
	    height: {
	      default: null
	    },
	    width: {
	      default: null
	    },
	    options: {
	      default: function _default() {}
	    },
	    videoId: {
	      required: true
	    },
	    loop: {
	      default: false
	    },
	    autoplay: {
	      default: false
	    }
	  },
	  watch: {
	    videoId: 'update'
	  },
	  data: function data() {
	    pid += 1;
	
	    return {
	      elementId: 'vimeo-player-' + pid,
	      player: null
	    };
	  },
	
	  methods: {
	    update: function update(videoId) {
	      this.player.loadVideo(videoId);
	    },
	    setSize: function setSize() {
	      console.log('setSize');
	    },
	    setEvents: function setEvents() {
	      var vm = this;
	
	      this.player.ready().then(function () {
	        vm.$emit('ready', vm.player);
	      });
	
	      this.player.on('play', function (data) {
	        vm.$emit('play', data, vm.player);
	      });
	
	      this.player.on('pause', function (data) {
	        vm.$emit('pause', data, vm.player);
	      });
	
	      this.player.on('ended', function (data) {
	        vm.$emit('ended', data, vm.player);
	      });
	
	      this.player.on('timeupdate', function (data) {
	        vm.$emit('timeupdate', data, vm.player);
	      });
	
	      this.player.on('progress', function (data) {
	        vm.$emit('progress', data, vm.player);
	      });
	
	      this.player.on('progress', function (data) {
	        vm.$emit('progress', data, vm.player);
	      });
	
	      this.player.on('seeked', function (data) {
	        vm.$emit('seeked', data, vm.player);
	      });
	
	      this.player.on('texttrackchange', function (data) {
	        vm.$emit('texttrackchange', data, vm.player);
	      });
	
	      this.player.on('texttrackchange', function (data) {
	        vm.$emit('texttrackchange', data, vm.player);
	      });
	
	      this.player.on('cuechange', function (data) {
	        vm.$emit('cuechange', data, vm.player);
	      });
	
	      this.player.on('volumechange', function (data) {
	        vm.$emit('volumechange', data, vm.player);
	      });
	
	      this.player.on('error', function (data) {
	        vm.$emit('error', data, vm.player);
	      });
	
	      this.player.on('loaded', function (data) {
	        vm.$emit('loaded', data, vm.player);
	      });
	    }
	  },
	  ready: function ready() {
	    var options = {
	      id: this.videoId,
	      width: this.width,
	      height: this.height,
	      loop: this.loop,
	      autoplay: this.autoplay
	    };
	    this.player = new _player2.default(this.elementId, (0, _assign2.default)(options, this.options));
	    this.setEvents();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.player.unload();
	  }
	};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _layout = __webpack_require__(358);
	
	exports.default = {
	  name: 'ListLayout',
	  components: {
	    Container: _layout.Container, Row: _layout.Row, Column: _layout.Column
	  }
	};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _view = __webpack_require__(13);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _Container = __webpack_require__(74);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Sprite = __webpack_require__(352);
	
	var _Sprite2 = _interopRequireDefault(_Sprite);
	
	var _ListItem = __webpack_require__(97);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _actions = __webpack_require__(150);
	
	var _getters = __webpack_require__(99);
	
	var _router = __webpack_require__(149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Dashboard',
	  mixins: [_view2.default],
	  vuex: {
	    actions: {
	      invalidateToken: _actions.invalidateToken
	    },
	    getters: {
	      role: _getters.role
	    }
	  },
	  data: function data() {
	    return {
	      items: [{
	        title: 'Øvelser',
	        link: {
	          name: 'exercises'
	        }
	      }, {
	        title: 'Hold',
	        link: {
	          name: 'teams'
	        }
	      }],
	      images: [__webpack_require__(735)]
	    };
	  },
	
	  computed: {
	    filteredItems: function filteredItems() {
	      var forbidden = [];
	      for (var key in _router.map) {
	        if (typeof _router.map[key].meta === 'undefined' || typeof _router.map[key].meta.forbiddenRoles === 'undefined') continue;
	
	        if (_router.map[key].meta.forbiddenRoles.includes(this.role) || this.role === null) {
	          forbidden.push(_router.map[key].name);
	        }
	      }
	      return this.items.filter(function (item) {
	        return !forbidden.includes(item.link.name);
	      });
	    }
	  },
	  components: {
	    Container: _Container2.default,
	    ListItem: _ListItem2.default,
	    Sprite: _Sprite2.default
	  },
	  methods: {
	    logout: function logout() {
	      this.invalidateToken().then(function (response) {
	        if (response.status === 200) {
	          window.location.href = '/login';
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _view = __webpack_require__(13);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _actions = __webpack_require__(76);
	
	var _getters = __webpack_require__(100);
	
	var _Container = __webpack_require__(74);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _FlipButton = __webpack_require__(350);
	
	var _FlipButton2 = _interopRequireDefault(_FlipButton);
	
	var _SubExercise = __webpack_require__(353);
	
	var _SubExercise2 = _interopRequireDefault(_SubExercise);
	
	var _Vimeo = __webpack_require__(798);
	
	var _Vimeo2 = _interopRequireDefault(_Vimeo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ExerciseView',
	  mixins: [_view2.default],
	  data: function data() {
	    return {
	      enableTransition: true
	    };
	  },
	
	  components: {
	    Container: _Container2.default,
	    FlipButton: _FlipButton2.default,
	    Subexercise: _SubExercise2.default,
	    Vimeo: _Vimeo2.default
	  },
	  ready: function ready() {
	    this.getExercise(this.$route.params.id);
	  },
	
	  computed: {
	    title: function title() {
	      return this.exercise.title;
	    }
	  },
	  vuex: {
	    actions: {
	      getExercise: _actions.getExercise
	    },
	    getters: {
	      exercise: _getters.activeExercise
	    }
	  }
	};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _view = __webpack_require__(13);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _exercises = __webpack_require__(148);
	
	var _exercises2 = _interopRequireDefault(_exercises);
	
	var _Exercise = __webpack_require__(786);
	
	var _Exercise2 = _interopRequireDefault(_Exercise);
	
	var _List = __webpack_require__(799);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(97);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Filters = __webpack_require__(349);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _Container = __webpack_require__(74);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _actions = __webpack_require__(76);
	
	var _getters = __webpack_require__(99);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ExercisesView',
	  mixins: [_view2.default, _exercises2.default],
	  components: {
	    Exercise: _Exercise2.default,
	    ListLayout: _List2.default,
	    ListItem: _ListItem2.default,
	    Filters: _Filters2.default,
	    Container: _Container2.default
	  },
	  data: function data() {
	    return {
	      title: 'Liste over øvelser',
	      options: {
	        onUpdate: this.onUpdate,
	        animation: 150
	      }
	    };
	  },
	
	  vuex: {
	    actions: {
	      updateIndex: _actions.updateIndex
	    },
	    getters: {
	      role: _getters.role
	    }
	  },
	  methods: {
	    getListItemLink: function getListItemLink(id) {
	      return {
	        name: 'exercise',
	        params: {
	          id: id
	        }
	      };
	    },
	    onUpdate: function onUpdate(e) {
	      this.updateIndex(e.oldIndex, e.newIndex);
	    }
	  },
	  computed: {
	    filtersVisible: function filtersVisible() {
	      return this.role !== 'facilitator';
	    }
	  }
	};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _view = __webpack_require__(13);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _getters = __webpack_require__(99);
	
	var _actions = __webpack_require__(150);
	
	var _InputGroup = __webpack_require__(789);
	
	var _InputGroup2 = _interopRequireDefault(_InputGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ViewLogin',
	  mixins: [_view2.default],
	  components: {
	    InputGroup: _InputGroup2.default
	  },
	  vuex: {
	    getters: {
	      isLoggedIn: _getters.isLoggedIn
	    },
	    actions: {
	      login: _actions.login
	    }
	  },
	  data: function data() {
	    return {
	      username: null,
	      password: null
	    };
	  },
	
	  watch: {
	    isLoggedIn: function isLoggedIn() {
	      if (this.isLoggedIn) {
	        this.$router.go({ name: 'root' });
	      }
	    }
	  },
	  methods: {
	    click: function click() {
	      this.login(this.username, this.password);
	    }
	  },
	  ready: function ready() {
	    this.setTitle('Velkommen til Funktionel Hjernetræning');
	  }
	};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(103);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(64);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _view = __webpack_require__(13);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _actions = __webpack_require__(102);
	
	var _resources = __webpack_require__(18);
	
	var _resources2 = __webpack_require__(18);
	
	var _TableData = __webpack_require__(355);
	
	var _TableData2 = _interopRequireDefault(_TableData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'NewTeam',
	  mixins: [_view2.default],
	  vuex: {
	    actions: {
	      newTeam: _actions.newTeam
	    }
	  },
	  components: {
	    TableData: _TableData2.default
	  },
	  data: function data() {
	    return {
	      name: '',
	      description: '',
	      attendees: [],
	      sending: false,
	      attendee: '',
	      mail: '',
	      survey_type: '',
	
	      host: _resources2.host,
	      predefinedType: 'none',
	      tableColumns: [{
	        key: 'name',
	        name: 'Navn',
	        sort: true
	      }, {
	        key: 'email',
	        name: 'Mail',
	        sort: true
	      }, {
	        key: 'survey_type',
	        name: 'Evaluering',
	        sort: true
	      }]
	    };
	  },
	
	  computed: {
	    classes: function classes() {
	      return {
	        disabled: this.sending
	      };
	    },
	    request: function request() {
	      return {
	        name: this.name,
	        description: this.description,
	        attendees: this.attendees,
	
	        exercise_group: this.predefinedType
	      };
	    },
	    attendeesDisplay: function attendeesDisplay() {
	      var _this = this;
	
	      var display = JSON.parse((0, _stringify2.default)(this.attendees));
	      return display.map(function (attendee) {
	        return (0, _assign2.default)({}, attendee, {
	          survey_type: attendee.survey_type === '' ? '-- ingen --' : _this.surveyTypes[attendee.survey_type]
	        });
	      });
	    }
	  },
	  asyncComputed: {
	    predefined: function predefined() {
	      return _resources.PredefinedExercises.get().then(function (response) {
	        return response.data;
	      });
	    },
	    surveyTypes: function surveyTypes() {
	      return _resources.SurveyTypes.get().then(function (response) {
	        return response.data;
	      });
	    }
	  },
	  methods: {
	    submit: function submit() {
	      var _this2 = this;
	
	      this.sending = true;
	      this.newTeam(this.request).then(function () {
	        _this2.sending = false;
	        _this2.$router.go({ name: 'teams' });
	      }).catch(function (error) {
	        console.log('an error occured', error);
	      });
	    },
	    addAttendee: function addAttendee() {
	      if (!this.$attendee.valid) {
	        alert('Alle felter for navn, e-mail og evaluering skal udfyldes');
	        return;
	      }
	      this.attendees.push({
	        name: this.attendee,
	        email: this.mail,
	        survey_type: this.survey_type,
	        remove: this.removeAttendee,
	        callback: function callback() {
	          this.remove(this);
	        }
	      });
	      this.attendee = '';
	      this.mail = '';
	      this.survey_type = '';
	    },
	    removeAttendee: function removeAttendee(attendee) {
	      this.attendees.splice(this.attendees.indexOf(attendee), 1);
	    },
	    onRemove: function onRemove(index) {
	      this.attendees.splice(index, 1);
	    }
	  }
	};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(64);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _view = __webpack_require__(13);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _Text = __webpack_require__(794);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _api = __webpack_require__(63);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _resources = __webpack_require__(18);
	
	var _Loader = __webpack_require__(147);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Notes',
	  mixins: [_view2.default],
	  components: {
	    Text: _Text2.default,
	    Loader: _Loader2.default
	  },
	  data: function data() {
	    return {
	      requesting: true,
	      saving: false,
	      text: null
	    };
	  },
	
	  methods: {
	    setText: function setText(text) {
	      this.text = text;
	    },
	    save: function save() {
	      var _this = this;
	
	      this.saving = true;
	      _resources.http.put('me/teams/' + this.id, (0, _stringify2.default)(this.request)).then(function (response) {
	        _this.saving = false;
	        console.log('%csaved note', 'font-weight: bold; color: green', response);
	      });
	    }
	  },
	  computed: {
	    id: function id() {
	      return parseInt(this.$route.params.team);
	    },
	    request: function request() {
	      return {
	        notes: this.text
	      };
	    },
	    notes: function notes() {
	      return this.team && this.team.notes;
	    }
	  },
	  asyncComputed: {
	    team: function team() {
	      var _this2 = this;
	
	      return _api2.default.getTeams().then(function (response) {
	        return response.data;
	      }).then(function (teams) {
	        return teams.find(function (team) {
	          _this2.requesting = false;
	          return team.id === _this2.id;
	        });
	      });
	    }
	  }
	};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(103);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(64);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _resources = __webpack_require__(18);
	
	var _view = __webpack_require__(13);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _HeaderGroup = __webpack_require__(75);
	
	var _HeaderGroup2 = _interopRequireDefault(_HeaderGroup);
	
	var _TableData = __webpack_require__(355);
	
	var _TableData2 = _interopRequireDefault(_TableData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Participants',
	  mixins: [_view2.default],
	  components: {
	    TableData: _TableData2.default, HeaderGroup: _HeaderGroup2.default
	  },
	  data: function data() {
	    return {
	      columns: [],
	      query: '',
	      team: {},
	      attendee: '',
	      mail: '',
	      survey_type: ''
	    };
	  },
	
	  computed: {
	    id: function id() {
	      return this.$route.params.team;
	    },
	    columns: function columns() {
	      return [{
	        key: 'id',
	        name: '#',
	        sort: true
	      }, {
	        key: 'name',
	        name: 'Navn',
	        sort: true
	      }, {
	        key: 'email',
	        name: 'Mail',
	        sort: true
	      }, {
	        key: 'survey_type',
	        name: 'Evaluering',
	        sort: true
	      }];
	    },
	    teamAttendeesDisplay: function teamAttendeesDisplay() {
	      var _this = this;
	
	      if (typeof this.team.attendees === 'undefined' || this.surveyTypes === null) {
	        return [];
	      }
	      var display = JSON.parse((0, _stringify2.default)(this.team.attendees));
	      return display.map(function (attendee) {
	        return (0, _assign2.default)({}, attendee, {
	          survey_type: attendee.survey_type === '' ? '-- ingen --' : _this.surveyTypes[attendee.survey_type]
	        });
	      });
	    }
	  },
	  methods: {
	    addAttendee: function addAttendee() {
	      if (!this.$attendee.valid) {
	        alert('Både navn og mail skal udfyldes');
	        return;
	      }
	
	      this.team.attendees.push({
	        name: this.attendee,
	        email: this.mail,
	        survey_type: this.survey_type
	      });
	      this.attendee = '';
	      this.mail = '';
	      this.survey_type = '';
	      this.save();
	    },
	    removeAttendee: function removeAttendee(attendee) {
	      this.team.attendees.splice(this.team.attendees.indexOf(attendee), 1);
	    },
	    save: function save() {
	      var _this2 = this;
	
	      _resources.http.put('me/teams/' + this.id, (0, _stringify2.default)(this.team)).then(function (response) {
	        if (response.ok) {
	          _this2.team = response.data.data;
	        }
	      });
	    },
	    onRemove: function onRemove(index) {
	      this.team.attendees.splice(index, 1);
	      this.save();
	    }
	  },
	  asyncComputed: {
	    initialTeam: function initialTeam() {
	      var _this3 = this;
	
	      return _resources.Teams.get({ id: this.id }).then(function (response) {
	        var team = response.data.find(function (team) {
	          return team.id === parseInt(_this3.id);
	        });
	        _this3.team = team;
	      });
	    },
	    surveyTypes: function surveyTypes() {
	      return _resources.SurveyTypes.get().then(function (response) {
	        return response.data;
	      });
	    }
	  }
	};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(64);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _view = __webpack_require__(13);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _HeaderGroup = __webpack_require__(75);
	
	var _HeaderGroup2 = _interopRequireDefault(_HeaderGroup);
	
	var _resources = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ResetPassword',
	  mixins: [_view2.default],
	  components: {
	    HeaderGroup: _HeaderGroup2.default
	  },
	  data: function data() {
	    return {
	      mail: '',
	      password: '',
	      passwordConfirmation: '',
	      submitting: false
	    };
	  },
	
	  computed: {
	    matchPassword: function matchPassword() {
	      return this.password === this.passwordConfirmation;
	    },
	    valid: function valid() {
	      return this.$resetPassword.valid && this.matchPassword;
	    },
	    token: function token() {
	      return this.$route.params.token;
	    },
	    response: function response() {
	      return {
	        email: this.mail,
	        password: this.password,
	        password_confirmation: this.passwordConfirmation
	      };
	    },
	    classes: function classes() {
	      return {
	        'inactive': this.submitting
	      };
	    }
	  },
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      if (!this.valid) {
	        alert('Felterne er ikke udfyldt tilstrækkeligt');
	        return;
	      }
	      this.submitting = true;
	      _resources.http.put('me/password/' + this.token, (0, _stringify2.default)(this.response)).then(function (response) {
	        console.log(response);
	        _this.submitting = false;
	        if (response.ok) {
	          _this.$router.go({ name: 'login' });
	        } else {
	          _this.onError(response);
	        }
	      }).catch(this.onError);
	    },
	    onError: function onError(error) {
	      this.submitting = false;
	      alert(JSON.parse(error.body).message);
	    }
	  }
	};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(64);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _view = __webpack_require__(13);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _exercises = __webpack_require__(148);
	
	var _exercises2 = _interopRequireDefault(_exercises);
	
	var _resources = __webpack_require__(18);
	
	var _HeaderGroup = __webpack_require__(75);
	
	var _HeaderGroup2 = _interopRequireDefault(_HeaderGroup);
	
	var _Filters = __webpack_require__(349);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SessionsView',
	  mixins: [_view2.default, _exercises2.default],
	  components: {
	    HeaderGroup: _HeaderGroup2.default, Filters: _Filters2.default
	  },
	  data: function data() {
	    var _this = this;
	
	    return {
	      sortableOptions: {
	        animation: 150,
	        delay: 150,
	        group: 'sessions',
	        scroll: false,
	        scrollSpeed: 0,
	        onAdd: function onAdd(e) {
	          console.log('%conAdd', 'font-weight: bold', e);
	          var sessionIndex = e.to.dataset.session;
	          var newExerciseIndex = e.newIndex;
	          var exercises = _this.sessions[sessionIndex].exercises;
	
	          var appendExercise = {
	            id: e.item.dataset.id,
	            status: 'pending',
	            subId: e.item.dataset.subId,
	            test: e.item.innerHTML
	          };
	          exercises.splice(newExerciseIndex, 0, appendExercise);
	
	          if (e.item.dataset.remove) {
	            e.item.parentNode.removeChild(e.item);
	          }
	
	          _this.save();
	        },
	        onRemove: function onRemove(e) {
	          console.log('%conRemove', 'font-weight: bold', e);
	          _this.sessions[e.item.dataset.session].exercises.splice(e.oldIndex, 1);
	          _this.save();
	        },
	        onUpdate: function onUpdate(e) {
	          console.log('%conUpdate', 'font-weight: bold');
	          var arr = _this.sessions[e.item.dataset.session].exercises;
	          var element = arr[e.oldIndex];
	          arr.splice(e.oldIndex, 1);
	          arr.splice(e.newIndex, 0, element);
	          _this.save();
	        }
	      },
	      sortableExercisesOptions: {
	        animation: 150,
	        delay: 150,
	        group: {
	          name: 'sessions',
	          pull: 'clone',
	          put: false
	        },
	        sort: false
	      }
	    };
	  },
	
	  computed: {
	    id: function id() {
	      return this.$route.params.team;
	    }
	  },
	  asyncComputed: {
	    sessions: function sessions() {
	      return _resources.Sessions.get({ id: this.id }).then(function (response) {
	        return response.data;
	      });
	    }
	  },
	  methods: {
	    setFilter: function setFilter(filter) {
	      this.filter = filter;
	    },
	    scrollToBottom: function scrollToBottom() {
	      this.$els.sessions.scrollTop = this.$els.sessions.scrollHeight;
	    },
	    getExercise: function getExercise(id) {
	      return this.allExercises.find(function (exercise) {
	        return exercise.id === parseInt(id);
	      });
	    },
	    addSession: function addSession() {
	      this.sessions.push({
	        exercises: []
	      });
	    },
	    deleteSession: function deleteSession(index) {
	      if (window.confirm('Sikker på du vil slette hele sessionen?')) {
	        this.sessions.splice(index, 1);
	        this.save();
	      }
	    },
	    removeExercise: function removeExercise(index, session) {
	      if (window.confirm('Sikker på du vil slette øvelsen?')) {
	        this.sessions[session].exercises.splice(index, 1);
	        this.save();
	      }
	    },
	    save: function save() {
	      console.log('%csave in progress', 'font-weight: bold; color: grey');
	      _resources.Sessions.update({ id: this.id }, (0, _stringify2.default)(this.sessions)).then(function (response) {
	        console.log('%csaved', 'font-weight: bold; color: green', response);
	      });
	    },
	    toggleStatus: function toggleStatus(exercise) {
	      exercise.status = exercise.status === 'done' ? 'pending' : 'done';
	      this.save();
	    }
	  }
	};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _view = __webpack_require__(13);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _actions = __webpack_require__(76);
	
	var _getters = __webpack_require__(100);
	
	var _SubExercise = __webpack_require__(353);
	
	var _SubExercise2 = _interopRequireDefault(_SubExercise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SubexerciseView',
	  mixins: [_view2.default],
	  components: {
	    Subexercise: _SubExercise2.default
	  },
	  data: function data() {
	    return {
	      loaded: false
	    };
	  },
	
	  computed: {
	    id: function id() {
	      return parseInt(this.$route.params.id);
	    },
	    subid: function subid() {
	      return parseInt(this.$route.params.subid);
	    },
	    subexercise: function subexercise() {
	      return this.exercise && this.exercise.exercises[this.subid];
	    }
	  },
	  vuex: {
	    getters: {
	      exercise: _getters.activeExercise
	    },
	    actions: {
	      getExercise: _actions.getExercise
	    }
	  },
	  ready: function ready() {
	    var _this = this;
	
	    this.getExercise(this.id).then(function (response) {
	      _this.loaded = true;
	    });
	  }
	};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _view = __webpack_require__(13);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _HeaderGroup = __webpack_require__(75);
	
	var _HeaderGroup2 = _interopRequireDefault(_HeaderGroup);
	
	var _Graph = __webpack_require__(787);
	
	var _Graph2 = _interopRequireDefault(_Graph);
	
	var _VerticalGraph = __webpack_require__(796);
	
	var _VerticalGraph2 = _interopRequireDefault(_VerticalGraph);
	
	var _Bar = __webpack_require__(347);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _api = __webpack_require__(63);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _resources = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Survey',
	  mixins: [_view2.default],
	  components: {
	    HeaderGroup: _HeaderGroup2.default, Graph: _Graph2.default, Bar: _Bar2.default, VerticalGraph: _VerticalGraph2.default
	  },
	  data: function data() {
	    return {
	      selectedIndex: 0,
	
	      sending: false
	    };
	  },
	
	  computed: {
	    id: function id() {
	      return parseInt(this.$route.params.team);
	    },
	    preAnswers: function preAnswers() {
	      if (this.activeAttendeeIsSharpBrains) {
	        return [];
	      } else {
	        return this.getSurvey('pre', 'answers') || [];
	      }
	    },
	    postAnswers: function postAnswers() {
	      var key = this.activeAttendeeIsSharpBrains ? 'sharp_brains' : 'post';
	
	      return this.getSurvey(key, 'answers') || [];
	    },
	    preComment: function preComment() {
	      return this.getSurvey('pre', 'comment');
	    },
	    postComment: function postComment() {
	      return this.getSurvey('post', 'comment');
	    },
	    activeAttendee: function activeAttendee() {
	      var _this = this;
	
	      return this.attendees && this.attendees.find(function (attendee) {
	        return attendee.id === _this.selectedIndex;
	      });
	    },
	    activeAttendeeName: function activeAttendeeName() {
	      return this.activeAttendee && this.activeAttendee.name;
	    },
	    activeAttendeeIsSharpBrains: function activeAttendeeIsSharpBrains() {
	      return this.activeAttendee && this.activeAttendee.survey_type === 'sharp_brains';
	    },
	    surveysNotDefined: function surveysNotDefined() {
	      return !this.surveys || !this.surveys.pre || !this.surveys.post;
	    },
	    attendees: function attendees() {
	      return this.team && this.team.attendees;
	    }
	  },
	  methods: {
	    setIndex: function setIndex(index) {
	      this.selectedIndex = index;
	    },
	    isActive: function isActive(index) {
	      return index === this.selectedIndex;
	    },
	    setClasses: function setClasses(index) {
	      return {
	        'has-survey': this.hasSurvey(index),
	        'chosen': this.isActive(index) };
	    },
	    hasSurvey: function hasSurvey(attendeeIndex) {
	      if (!this.surveys) return;
	
	      var attendee = this.attendees && this.attendees.find(function (attendee) {
	        return attendee.id === attendeeIndex;
	      });
	      var searchSurveyType = attendee.survey_type === 'sharp_brains' ? 'sharp_brains' : 'pre';
	      return this.surveys[searchSurveyType].find(function (survey) {
	        return survey.attendee.id === attendeeIndex;
	      });
	    },
	    getSurvey: function getSurvey(key, key2) {
	      var _this2 = this;
	
	      if (this.surveysNotDefined) return;
	
	      var survey = this.surveys[key].find(function (survey) {
	        return survey.attendee.id === _this2.selectedIndex;
	      });
	      if (survey) return survey[key2];
	    },
	    sendSurvey: function sendSurvey(type, attendeeId) {
	      var _this3 = this;
	
	      if (this.sending !== false) {
	        return;
	      }
	      this.sending = attendeeId;
	      _resources.http.post('me/teams/' + this.id + '/survey/' + type + '/attendee/' + attendeeId).then(function (response) {
	        _this3.sending = false;
	        console.log(response);
	      });
	    },
	    hasAnswer: function hasAnswer(type, index) {
	      return this[type + 'Answers'] && this[type + 'Answers'][index];
	    },
	    allowSendEvaluation: function allowSendEvaluation(attendee, type) {
	      return attendee.evaluations.includes(type);
	    },
	    surveyAlreadyAnswered: function surveyAlreadyAnswered(attendee, type) {
	      return this.surveys === null || this.surveys[type].find(function (survey) {
	        return survey.attendee.id === attendee.id;
	      });
	    },
	    surveyTypeDisplay: function surveyTypeDisplay(attendee) {
	      if (this.surveyTypes === null) {
	        return '';
	      }
	      return attendee.survey_type === '' ? '-- ingen --' : this.surveyTypes[attendee.survey_type];
	    }
	  },
	  asyncComputed: {
	    surveys: function surveys() {
	      return _api2.default.getSurvey(this.id);
	    },
	    team: function team() {
	      var _this4 = this;
	
	      return _api2.default.getTeams().then(function (response) {
	        return response.data;
	      }).then(function (teams) {
	        return teams.find(function (team) {
	          return team.id === _this4.id;
	        });
	      });
	    },
	    surveyTypes: function surveyTypes() {
	      return _resources.SurveyTypes.get().then(function (response) {
	        return response.data;
	      });
	    }
	  }
	};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _view = __webpack_require__(13);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _HeaderGroup = __webpack_require__(75);
	
	var _HeaderGroup2 = _interopRequireDefault(_HeaderGroup);
	
	var _ListItem = __webpack_require__(97);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _getters = __webpack_require__(151);
	
	var _actions = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Team',
	  mixins: [_view2.default],
	  components: {
	    HeaderGroup: _HeaderGroup2.default, ListItem: _ListItem2.default
	  },
	  vuex: {
	    getters: {
	      team: _getters.activeTeam
	    },
	    actions: {
	      setActiveTeam: _actions.setActiveTeam
	    }
	  },
	  data: function data() {
	    return {
	      items: [{
	        title: 'Sessions',
	        link: {
	          name: 'sessions'
	        }
	      }, {
	        title: 'Deltagere',
	        link: {
	          name: 'participants'
	        }
	      }, {
	        title: 'Evalueringer',
	        link: {
	          name: 'survey'
	        }
	      }, {
	        title: 'Noter',
	        link: {
	          name: 'notes'
	        }
	      }]
	    };
	  },
	
	  computed: {
	    id: function id() {
	      return this.$route.params.team;
	    }
	  },
	  ready: function ready() {
	    this.setActiveTeam(this.id);
	  }
	};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _view = __webpack_require__(13);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _ListItem = __webpack_require__(97);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _FlipButton = __webpack_require__(350);
	
	var _FlipButton2 = _interopRequireDefault(_FlipButton);
	
	var _getters = __webpack_require__(151);
	
	var _actions = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TeamsView',
	  mixins: [_view2.default],
	  components: {
	    ListItem: _ListItem2.default,
	    FlipButton: _FlipButton2.default
	  },
	  vuex: {
	    getters: {
	      teams: _getters.allTeams
	    },
	    actions: {
	      getAllTeams: _actions.getAllTeams
	    }
	  },
	  ready: function ready() {
	    this.getAllTeams();
	  }
	};

/***/ }),
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 703 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 209,
		"./af.js": 209,
		"./ar": 216,
		"./ar-dz": 210,
		"./ar-dz.js": 210,
		"./ar-kw": 211,
		"./ar-kw.js": 211,
		"./ar-ly": 212,
		"./ar-ly.js": 212,
		"./ar-ma": 213,
		"./ar-ma.js": 213,
		"./ar-sa": 214,
		"./ar-sa.js": 214,
		"./ar-tn": 215,
		"./ar-tn.js": 215,
		"./ar.js": 216,
		"./az": 217,
		"./az.js": 217,
		"./be": 218,
		"./be.js": 218,
		"./bg": 219,
		"./bg.js": 219,
		"./bm": 220,
		"./bm.js": 220,
		"./bn": 222,
		"./bn-bd": 221,
		"./bn-bd.js": 221,
		"./bn.js": 222,
		"./bo": 223,
		"./bo.js": 223,
		"./br": 224,
		"./br.js": 224,
		"./bs": 225,
		"./bs.js": 225,
		"./ca": 226,
		"./ca.js": 226,
		"./cs": 227,
		"./cs.js": 227,
		"./cv": 228,
		"./cv.js": 228,
		"./cy": 229,
		"./cy.js": 229,
		"./da": 230,
		"./da.js": 230,
		"./de": 233,
		"./de-at": 231,
		"./de-at.js": 231,
		"./de-ch": 232,
		"./de-ch.js": 232,
		"./de.js": 233,
		"./dv": 234,
		"./dv.js": 234,
		"./el": 235,
		"./el.js": 235,
		"./en-au": 236,
		"./en-au.js": 236,
		"./en-ca": 237,
		"./en-ca.js": 237,
		"./en-gb": 238,
		"./en-gb.js": 238,
		"./en-ie": 239,
		"./en-ie.js": 239,
		"./en-il": 240,
		"./en-il.js": 240,
		"./en-in": 241,
		"./en-in.js": 241,
		"./en-nz": 242,
		"./en-nz.js": 242,
		"./en-sg": 243,
		"./en-sg.js": 243,
		"./eo": 244,
		"./eo.js": 244,
		"./es": 248,
		"./es-do": 245,
		"./es-do.js": 245,
		"./es-mx": 246,
		"./es-mx.js": 246,
		"./es-us": 247,
		"./es-us.js": 247,
		"./es.js": 248,
		"./et": 249,
		"./et.js": 249,
		"./eu": 250,
		"./eu.js": 250,
		"./fa": 251,
		"./fa.js": 251,
		"./fi": 252,
		"./fi.js": 252,
		"./fil": 253,
		"./fil.js": 253,
		"./fo": 254,
		"./fo.js": 254,
		"./fr": 257,
		"./fr-ca": 255,
		"./fr-ca.js": 255,
		"./fr-ch": 256,
		"./fr-ch.js": 256,
		"./fr.js": 257,
		"./fy": 258,
		"./fy.js": 258,
		"./ga": 259,
		"./ga.js": 259,
		"./gd": 260,
		"./gd.js": 260,
		"./gl": 261,
		"./gl.js": 261,
		"./gom-deva": 262,
		"./gom-deva.js": 262,
		"./gom-latn": 263,
		"./gom-latn.js": 263,
		"./gu": 264,
		"./gu.js": 264,
		"./he": 265,
		"./he.js": 265,
		"./hi": 266,
		"./hi.js": 266,
		"./hr": 267,
		"./hr.js": 267,
		"./hu": 268,
		"./hu.js": 268,
		"./hy-am": 269,
		"./hy-am.js": 269,
		"./id": 270,
		"./id.js": 270,
		"./is": 271,
		"./is.js": 271,
		"./it": 273,
		"./it-ch": 272,
		"./it-ch.js": 272,
		"./it.js": 273,
		"./ja": 274,
		"./ja.js": 274,
		"./jv": 275,
		"./jv.js": 275,
		"./ka": 276,
		"./ka.js": 276,
		"./kk": 277,
		"./kk.js": 277,
		"./km": 278,
		"./km.js": 278,
		"./kn": 279,
		"./kn.js": 279,
		"./ko": 280,
		"./ko.js": 280,
		"./ku": 281,
		"./ku.js": 281,
		"./ky": 282,
		"./ky.js": 282,
		"./lb": 283,
		"./lb.js": 283,
		"./lo": 284,
		"./lo.js": 284,
		"./lt": 285,
		"./lt.js": 285,
		"./lv": 286,
		"./lv.js": 286,
		"./me": 287,
		"./me.js": 287,
		"./mi": 288,
		"./mi.js": 288,
		"./mk": 289,
		"./mk.js": 289,
		"./ml": 290,
		"./ml.js": 290,
		"./mn": 291,
		"./mn.js": 291,
		"./mr": 292,
		"./mr.js": 292,
		"./ms": 294,
		"./ms-my": 293,
		"./ms-my.js": 293,
		"./ms.js": 294,
		"./mt": 295,
		"./mt.js": 295,
		"./my": 296,
		"./my.js": 296,
		"./nb": 297,
		"./nb.js": 297,
		"./ne": 298,
		"./ne.js": 298,
		"./nl": 300,
		"./nl-be": 299,
		"./nl-be.js": 299,
		"./nl.js": 300,
		"./nn": 301,
		"./nn.js": 301,
		"./oc-lnc": 302,
		"./oc-lnc.js": 302,
		"./pa-in": 303,
		"./pa-in.js": 303,
		"./pl": 304,
		"./pl.js": 304,
		"./pt": 306,
		"./pt-br": 305,
		"./pt-br.js": 305,
		"./pt.js": 306,
		"./ro": 307,
		"./ro.js": 307,
		"./ru": 308,
		"./ru.js": 308,
		"./sd": 309,
		"./sd.js": 309,
		"./se": 310,
		"./se.js": 310,
		"./si": 311,
		"./si.js": 311,
		"./sk": 312,
		"./sk.js": 312,
		"./sl": 313,
		"./sl.js": 313,
		"./sq": 314,
		"./sq.js": 314,
		"./sr": 316,
		"./sr-cyrl": 315,
		"./sr-cyrl.js": 315,
		"./sr.js": 316,
		"./ss": 317,
		"./ss.js": 317,
		"./sv": 318,
		"./sv.js": 318,
		"./sw": 319,
		"./sw.js": 319,
		"./ta": 320,
		"./ta.js": 320,
		"./te": 321,
		"./te.js": 321,
		"./tet": 322,
		"./tet.js": 322,
		"./tg": 323,
		"./tg.js": 323,
		"./th": 324,
		"./th.js": 324,
		"./tk": 325,
		"./tk.js": 325,
		"./tl-ph": 326,
		"./tl-ph.js": 326,
		"./tlh": 327,
		"./tlh.js": 327,
		"./tr": 328,
		"./tr.js": 328,
		"./tzl": 329,
		"./tzl.js": 329,
		"./tzm": 331,
		"./tzm-latn": 330,
		"./tzm-latn.js": 330,
		"./tzm.js": 331,
		"./ug-cn": 332,
		"./ug-cn.js": 332,
		"./uk": 333,
		"./uk.js": 333,
		"./ur": 334,
		"./ur.js": 334,
		"./uz": 336,
		"./uz-latn": 335,
		"./uz-latn.js": 335,
		"./uz.js": 336,
		"./vi": 337,
		"./vi.js": 337,
		"./x-pseudo": 338,
		"./x-pseudo.js": 338,
		"./yo": 339,
		"./yo.js": 339,
		"./zh-cn": 340,
		"./zh-cn.js": 340,
		"./zh-hk": 341,
		"./zh-hk.js": 341,
		"./zh-mo": 342,
		"./zh-mo.js": 342,
		"./zh-tw": 343,
		"./zh-tw.js": 343
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 725;


/***/ }),
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><symbol viewBox=\"0 0 14 24\" id=\"arrow-back-left\"><path d=\"M12.9 23.9c-.2 0-.5-.1-.7-.3L.3 12.6c-.2-.1-.3-.4-.3-.6 0-.3.1-.5.3-.7L12.2.3c.4-.4 1-.3 1.4.1s.3 1-.1 1.4L2.5 12l11.1 10.2c.4.4.4 1 .1 1.4-.2.2-.5.3-.8.3z\"></path></symbol><symbol preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 23.88 23.91\" id=\"formula-2\"><path d=\"M23.6 21.616l-1.992 1.993a.997.997 0 0 1-1.409-1.409l.292-.292H2.971a.995.995 0 0 1-.996-.996V3.391l-.292.292A.996.996 0 0 1 .274 2.274L2.266.282a.996.996 0 0 1 1.409 0l1.993 1.992a.996.996 0 0 1-1.409 1.409l-.349-.349V19.94l16.582-.023-.293-.292a.998.998 0 0 1 1.409-1.41l1.992 1.992a.996.996 0 0 1 0 1.409zm-15.648-4.69a.995.995 0 1 1 0-1.992c6.043 0 10.959-4.916 10.959-10.959a.996.996 0 0 1 1.992 0c0 7.142-5.81 12.951-12.951 12.951z\" class=\"bcls-1\"></path></symbol><symbol viewBox=\"0 0 136 26\" id=\"logo\"><path d=\"M.9 9.8V.2H6c2.3 0 3.5 1.5 3.5 3.3 0 1.8-1.2 3.3-3.5 3.3H3.8v3H.9zm5.6-6.3c0-.5-.4-.8-.9-.8H3.8v1.5h1.9c.4 0 .8-.2.8-.7zm6.3 6.3V.2h2.9v7.1h3.7v2.6h-6.6zm9.8-3.9V.2h3v5.6c0 .9.6 1.7 1.8 1.7 1.2 0 1.8-.7 1.8-1.7V.2h3v5.7c0 2.4-1.5 4.2-4.8 4.2s-4.8-1.8-4.8-4.2zm12.9 2.6L37 6.3c.7.7 1.8 1.2 3.1 1.2.6 0 1.1-.1 1.1-.5 0-.9-5.4 0-5.4-3.8 0-1.6 1.4-3.2 4-3.2 1.6 0 3 .4 4.1 1.3l-1.6 2.1c-.8-.6-1.9-1-2.8-1-.6 0-.7.2-.7.4 0 .9 5.4.1 5.4 3.7 0 2.1-1.6 3.4-4.2 3.4-2.1.1-3.5-.5-4.5-1.4zM.9 25.8v-9.7H6c2.3 0 3.5 1.5 3.5 3.3 0 1.8-1.2 3.3-3.5 3.3H3.8v3H.9zm5.6-6.3c0-.5-.4-.8-.9-.8H3.8v1.5h1.9c.4 0 .8-.2.8-.7zm6.7 6.3v-9.7h7.3v2.6h-4.4v1h4.3v2.6h-4.3v1.1h4.4V26h-7.3zm17 0l-1.3-3h-1.1v3h-2.9v-9.7h5.2c2.3 0 3.5 1.5 3.5 3.3 0 1.7-1 2.6-1.7 2.9l1.8 3.4h-3.5zm.4-6.4c0-.5-.5-.8-1-.8h-1.8v1.5h1.8c.5.1 1-.1 1-.7zm6.9 6.4v-9.7h7.3v2.6h-4.4v1h4.3v2.6h-4.3v3.6h-2.9zM47.9 21c0-3 2.3-5 5.3-5s5.3 2 5.3 5-2.3 5-5.3 5-5.3-2.1-5.3-5zm7.6 0c0-1.3-.9-2.4-2.3-2.4s-2.3 1.1-2.3 2.4c0 1.3.9 2.4 2.3 2.4s2.3-1.1 2.3-2.4zm11.4 4.8l-1.3-3h-1.1v3h-2.9v-9.7h5.2c2.3 0 3.5 1.5 3.5 3.3 0 1.7-1 2.6-1.7 2.9l1.8 3.4h-3.5zm.4-6.4c0-.5-.5-.8-1-.8h-1.8v1.5h1.8c.5.1 1-.1 1-.7zm15.2 6.4V20l-2.2 5.8H79L76.9 20v5.8H74v-9.7h4l1.7 4.6 1.7-4.6h4v9.7h-2.9zm13.4 0l-.3-1.1h-3.5l-.3 1.1h-3.3l3.6-9.7h3.7l3.6 9.7h-3.5zm-2-6.8l-1 3.1h1.9l-.9-3.1zm14.8 6.8l-3.6-4.9v4.9h-2.9v-9.7h3l3.4 4.6v-4.6h2.9v9.7h-2.8zm6-4.8c0-3 2.3-5 5.3-5 2.5 0 3.8 1.5 4.4 2.8l-2.5 1.2c-.2-.8-1-1.4-1.9-1.4-1.4 0-2.3 1.1-2.3 2.4 0 1.3.9 2.4 2.3 2.4.9 0 1.6-.7 1.9-1.4l2.5 1.2c-.6 1.3-1.9 2.8-4.4 2.8-3 0-5.3-2.1-5.3-5zm13.1 4.8v-9.7h7.3v2.6h-4.4v1h4.3v2.6h-4.3v1.1h4.4V26h-7.3z\"></path></symbol><symbol viewBox=\"0 0 594.4 175.7\" id=\"logo-large\"><path d=\"M209.8 131.9l-27-26.9c-.2-.2-.1-.5.1-.6 10.3-5.4 17.5-12.3 21.2-20.8 4-8.9 3.8-19-.5-29.2-6.6-15.7-22.3-29.5-42-37.1-22.1-8.5-46.5-8-68.7 1.3l-61.2 26c-2.4 1-3 4.1-1.1 5.9l112.4 112c2.5 2.5 6.3 3.2 9.6 1.9L208 141c3.7-1.6 4.6-6.3 1.8-9.1zM40.3 49.8c-.2-.2-.1-.5.1-.6l55.4-23.6c20.4-8.6 42.8-9 63.1-1.2 17.8 6.8 31.9 19.2 37.7 33 3.2 7.6 3.6 15 1.1 21.7-.1.3-.4.3-.6.1-9.1-12.3-23.6-22.2-40.4-27.4-14.6-4.6-37.4-7.8-63.5 3.2L60.5 68.9c-.4.2-.9.1-1.2-.2l-19-18.9zm109.3 107.9c-.4.2-.9.1-1.2-.2L65.9 75.3c-.2-.2-.1-.5.1-.6l30.2-12.8c23.9-10.1 44.9-7.2 58.3-2.9 16.4 5.2 30.4 15.1 38.5 27.2.3.4.2.9-.1 1.3-4.2 5-10.4 9.2-18.4 12.6-1.5.6-2.3 2-2.3 3.4v30.6c0 .9.4 1.9 1 2.5l7.3 7.3c.2.2.1.5-.1.6l-30.8 13.2zm38.4-17.1l-7.9-7.9c-.2-.2-.3-.5-.3-.8v-18.6c0-.3.4-.5.6-.3l21.8 21.7c.2.2.1.5-.1.6l-12.9 5.5c-.5.2-.9.1-1.2-.2zM257.4 82V59.6h11.9c5.2 0 8 3.5 8 7.7s-2.8 7.6-8 7.6h-5.2v7h-6.7zm13.1-14.7c0-1.2-.9-1.8-2-1.8h-4.3V69h4.3c1.1 0 2-.5 2-1.7zM285 82V59.6h6.8V76h8.5v6H285zm22.6-9.2V59.6h6.9v12.9c0 2.1 1.4 3.9 4.2 3.9 2.7 0 4.2-1.7 4.2-3.9V59.6h6.9v13.1c0 5.6-3.5 9.6-11 9.6s-11.2-4-11.2-9.5zm29.9 6l3.5-5c1.7 1.6 4.2 2.9 7.2 2.9 1.3 0 2.5-.3 2.5-1.2 0-2.1-12.5 0-12.5-8.8 0-3.8 3.1-7.4 9.3-7.4 3.7 0 6.9 1 9.5 3.1l-3.6 4.8c-1.9-1.5-4.5-2.2-6.6-2.2-1.3 0-1.7.4-1.7 1 0 2.1 12.4.3 12.4 8.6 0 4.9-3.7 7.8-9.6 7.8-4.8 0-8.1-1.4-10.4-3.6zm-80.1 41.6V98.1h11.9c5.2 0 8 3.5 8 7.7s-2.8 7.6-8 7.6h-5.2v7h-6.7zm13.1-14.6c0-1.2-.9-1.8-2-1.8h-4.3v3.5h4.3c1.1 0 2-.6 2-1.7zm15.5 14.6V98.1h16.9v5.9h-10.2v2.2h9.9v5.9h-9.9v2.4h10.2v5.9H286zm39.3 0l-3.1-7h-2.4v7H313V98.1h11.9c5.2 0 8 3.5 8 7.7 0 3.9-2.2 5.9-4 6.8l4.1 7.9h-7.7zm.8-14.7c0-1.2-1.1-1.7-2.2-1.7h-4.1v3.5h4.1c1.1 0 2.2-.5 2.2-1.8zm15.9 14.7V98.1h17v5.9h-10.2v2.2h9.9v5.9h-9.9v8.3H342zm24-11.1c0-6.9 5.3-11.6 12.2-11.6s12.2 4.7 12.2 11.6c0 6.9-5.3 11.6-12.2 11.6s-12.2-4.7-12.2-11.6zm17.6 0c0-3.1-2.1-5.6-5.4-5.6s-5.4 2.5-5.4 5.6 2.1 5.6 5.4 5.6 5.4-2.5 5.4-5.6zm26.4 11.1l-3.1-7h-2.4v7h-6.8V98.1h11.9c5.2 0 8 3.5 8 7.7 0 3.9-2.2 5.9-4 6.8l4.1 7.9H410zm.8-14.7c0-1.2-1.1-1.7-2.2-1.7h-4.1v3.5h4.1c1.2 0 2.2-.5 2.2-1.8zm35.3 14.7V107l-5 13.4h-3l-5-13.4v13.4h-6.8V98.1h9.3l3.9 10.7 3.9-10.7h9.3v22.3h-6.6zm31 0l-.8-2.6h-8l-.8 2.6h-7.7l8.2-22.3h8.5l8.2 22.3h-7.6zm-4.9-15.7l-2.2 7.2h4.4l-2.2-7.2zm34.5 15.7l-8.2-11.3v11.3h-6.8V98.1h7l7.8 10.6V98.1h6.8v22.3h-6.6zm13.7-11.1c0-6.9 5.3-11.6 12.3-11.6 5.9 0 8.8 3.4 10.1 6.5l-5.8 2.7c-.6-1.7-2.3-3.2-4.3-3.2-3.2 0-5.4 2.5-5.4 5.6s2.2 5.6 5.4 5.6c2 0 3.8-1.5 4.3-3.2l5.8 2.7c-1.3 3-4.3 6.5-10.1 6.5-7-.1-12.3-4.7-12.3-11.6zm30.3 11.1V98.1h16.9v5.9h-10.2v2.2h9.9v5.9h-9.9v2.4h10.2v5.9h-16.9z\"></path></symbol><symbol preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 24.28 24\" id=\"physics-1\"><path d=\"M23.279 8.062c-.551 1.272-1.319 2.602-2.248 3.938.929 1.336 1.697 2.666 2.248 3.938 1.343 3.101 1.304 5.58-.111 6.979-.725.719-1.729 1.083-2.981 1.083-2.201 0-5.091-1.192-8.053-3.207C9.172 22.808 6.282 24 4.082 24h-.001c-1.235 0-2.267-.374-2.982-1.083-1.415-1.399-1.454-3.878-.111-6.979.551-1.272 1.32-2.602 2.249-3.938-.929-1.336-1.698-2.667-2.249-3.938-1.343-3.101-1.304-5.58.111-6.979C1.824.364 2.828 0 4.081 0c2.2 0 5.09 1.192 8.053 3.206C15.096 1.192 17.986 0 20.187 0c1.235 0 2.266.374 2.981 1.083 1.416 1.399 1.455 3.878.111 6.979zM20.187 22c.696 0 1.219-.167 1.552-.497.768-.759.649-2.545-.318-4.777a20.059 20.059 0 0 0-1.661-3.024 36.222 36.222 0 0 1-2.784 3.089 36.004 36.004 0 0 1-3.116 2.739c2.392 1.543 4.66 2.47 6.327 2.47zm-17.34-5.274c-.967 2.232-1.087 4.018-.319 4.777.334.33.856.497 1.553.497 1.667 0 3.935-.926 6.327-2.47a35.85 35.85 0 0 1-5.9-5.828 20.148 20.148 0 0 0-1.661 3.024zM4.081 2c-.697 0-1.219.167-1.553.497-.768.759-.648 2.545.319 4.777a20.14 20.14 0 0 0 1.661 3.023 35.87 35.87 0 0 1 5.9-5.828C8.016 2.926 5.747 2 4.081 2zm4.64 6.623a33.818 33.818 0 0 0-2.99 3.376 33.716 33.716 0 0 0 6.403 6.327A33.818 33.818 0 0 0 18.537 12a33.716 33.716 0 0 0-6.403-6.326 33.826 33.826 0 0 0-3.413 2.949zm13.018-6.126c-.333-.33-.856-.497-1.552-.497-1.667 0-3.935.926-6.327 2.469a36.029 36.029 0 0 1 3.117 2.74 36.536 36.536 0 0 1 2.784 3.088 20.082 20.082 0 0 0 1.66-3.023c.968-2.232 1.086-4.018.318-4.777zM12.134 14a2.013 2.013 0 0 1-2.021-2c0-1.103.907-2 2.021-2 1.114 0 2.022.897 2.022 2s-.908 2-2.022 2z\" class=\"ecls-1\"></path></symbol><symbol preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 20 24\" id=\"user\"><path d=\"M19 24H1a1 1 0 0 1-1-1v-.667c0-4.148 3.08-7.763 7.177-8.933C4.72 12.312 3 9.855 3 7c0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.855-1.72 5.312-4.177 6.4C16.92 14.57 20 18.185 20 22.333V23a1 1 0 0 1-1 1zM15 7c0-2.757-2.243-5-5-5S5 4.243 5 7s2.243 5 5 5 5-2.243 5-5zm-5 8c-4.215 0-7.794 3.173-7.991 7h15.982c-.197-3.827-3.776-7-7.991-7z\" class=\"fcls-1\"></path></symbol></svg>"

/***/ }),
/* 733 */,
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/loader.50af38a.png";

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/virker-det.6779612.png";

/***/ }),
/* 736 */,
/* 737 */
/***/ (function(module, exports) {

	module.exports = " <main class=app> <top :title=title></top> <view></view> <grid :columns.sync=columns></grid> <symbols></symbols> </main> ";

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	module.exports = " <g class=axis :class=classes :transform=transform :style=style></g> ";

/***/ }),
/* 739 */
/***/ (function(module, exports) {

	module.exports = " <div class=component-grid> <div class=container-grid> <div class=row-grid> <div class=column-grid v-for=\"n in columns\"> <div class=gutter></div> </div> </div> </div> <input type=number slot=right v-model=columns number> </div> ";

/***/ }),
/* 740 */
/***/ (function(module, exports) {

	module.exports = " <svg :class=classes> <use xmlns:xlink=http://www.w3.org/1999/xlink :xlink:href=id></use> </svg> ";

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	module.exports = " <div class=text> <textarea></textarea> </div> ";

/***/ }),
/* 742 */
/***/ (function(module, exports) {

	module.exports = " <div class=component-view> <loader v-show=loading></loader> <router-view class=view></router-view> </div> ";

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	module.exports = " <div class=view-exercise _v-051e30a4=\"\"> <container _v-051e30a4=\"\"> <h1 _v-051e30a4=\"\">{{exercise.title}}</h1> <p class=manchette _v-051e30a4=\"\"> {{{exercise.intro}}} </p> <h4 _v-051e30a4=\"\">Organisation</h4> {{{exercise.organisation}}} <h4 _v-051e30a4=\"\">Udstyr</h4> {{{exercise.gear}}} <h4 _v-051e30a4=\"\">Variationer</h4> {{{exercise.possibilities}}} <h4 _v-051e30a4=\"\">Beskrivelse</h4> {{{exercise.description}}} <h4 _v-051e30a4=\"\">Fra træning til hverdag</h4> {{{exercise.note}}} <div class=video v-if=exercise.video _v-051e30a4=\"\"> <vimeo :video-id=exercise.video _v-051e30a4=\"\"></vimeo> <h4 _v-051e30a4=\"\"> <a href={{exercise.video}} target=_blank class=color-tint _v-051e30a4=\"\">Gå til video →</a> </h4> </div> <h2 _v-051e30a4=\"\">Progressioner</h2> <subexercise v-for=\"subexercise in exercise.exercises\" :exercise=subexercise :index=$index _v-051e30a4=\"\"> </subexercise> </container> </div> ";

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	module.exports = " <div class=session _v-0609e800=\"\"> <container _v-0609e800=\"\"> <header _v-0609e800=\"\"> <h2 _v-0609e800=\"\">Noter <span class=\"save color-tint\" v-if=!requesting @click=save _v-0609e800=\"\">Gem</span></h2> </header> <text v-if=\"notes || team\" v-show=!saving :initial-text=notes @value=setText _v-0609e800=\"\"> </text> <loader v-if=\"requesting || saving\" _v-0609e800=\"\"></loader> </container> </div> ";

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	module.exports = " <div class=reset-password :class=classes _v-06429a6e=\"\"> <container _v-06429a6e=\"\"> <header-group heading=\"Opret adgangskode\" subheading=\"Indtast mail og adgangskode\" _v-06429a6e=\"\"></header-group> <validator name=resetPassword _v-06429a6e=\"\"> <form novalidate=\"\" _v-06429a6e=\"\"> <div class=input-group _v-06429a6e=\"\"> <div class=field _v-06429a6e=\"\"> <label for=name _v-06429a6e=\"\">Mail</label> <input v-model=mail v-validate:email=\"['required', 'email']\" v-on:keyup.enter=submit type=text _v-06429a6e=\"\"> </div> </div> <div class=input-group _v-06429a6e=\"\"> <div class=field _v-06429a6e=\"\"> <label for=name _v-06429a6e=\"\">Adgangskode</label> <input v-model=password v-validate:password=\"{required: true, minlength: 6}\" v-on:keyup.enter=submit type=password _v-06429a6e=\"\"> </div> <div class=field _v-06429a6e=\"\"> <label for=name _v-06429a6e=\"\">Adgangskode</label> <input v-model=passwordConfirmation v-validate:password-confirmation=\"{required: true, match: matchPassword}\" v-on:keyup.enter=submit type=password _v-06429a6e=\"\"> </div> </div> <div class=errors _v-06429a6e=\"\"> <p v-if=$resetPassword.email.required _v-06429a6e=\"\">Mail krævet</p> <p v-if=$resetPassword.email.email _v-06429a6e=\"\">Gyldig mail krævet</p> <p v-if=$resetPassword.password.minlength _v-06429a6e=\"\">Adgangskode skal være på minimum 6 karakterer</p> <p v-if=!matchPassword _v-06429a6e=\"\">Adgangskoder matcher ikke</p> </div> <div class=button v-if=valid @click=submit _v-06429a6e=\"\">Opret adgangskode</div> </form> </validator> </container> </div> ";

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	module.exports = " <div class=participants _v-0eb4a131=\"\"> <container _v-0eb4a131=\"\"> <header-group heading=Deltagere subheading=\"Liste over deltagere\" _v-0eb4a131=\"\"> </header-group> <form id=search _v-0eb4a131=\"\"> <label _v-0eb4a131=\"\">Søg</label> <input name=query v-model=query placeholder=\"E.g. David\" _v-0eb4a131=\"\"> </form> <table-data v-if=team :data=teamAttendeesDisplay :columns=columns :filter-key=query @remove=onRemove _v-0eb4a131=\"\"> </table-data> <div class=field _v-0eb4a131=\"\"> <validator name=attendee _v-0eb4a131=\"\"> <form novalidate=\"\" _v-0eb4a131=\"\"> <h2 _v-0eb4a131=\"\">Tilføj deltager</h2> <div class=input-group _v-0eb4a131=\"\"> <div class=field _v-0eb4a131=\"\"> <label for=attendee-name _v-0eb4a131=\"\">Deltager</label> <input v-model=attendee v-validate:attendee=\"{ required: true }\" v-on:keyup.enter=addAttendee type=text id=attendee-name _v-0eb4a131=\"\"> </div> <div class=field _v-0eb4a131=\"\"> <label for=attendee-mail _v-0eb4a131=\"\">Mail</label> <input v-model=mail v-validate:mail=\"['required', 'email']\" v-on:keyup.enter=addAttendee type=text id=attendee-mail _v-0eb4a131=\"\"> </div> <div class=field _v-0eb4a131=\"\"> <label for=attendee-survey-type _v-0eb4a131=\"\">Evaluering</label> <select v-model=survey_type v-on:keyup.enter=addAttendee id=attendee-survey-type _v-0eb4a131=\"\"> <option value=\"\" _v-0eb4a131=\"\">-- ingen --</option> <option v-for=\"(key, label) in surveyTypes\" :value=key _v-0eb4a131=\"\">{{label}}</option> </select> </div> </div> <button class=\"button pointer-hover\" v-if=$attendee.valid @click=addAttendee _v-0eb4a131=\"\">Tilføj deltager</button> </form> </validator> </div> </container> </div> ";

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	module.exports = " <div class=loader transition=loader _v-0fc6258c=\"\"> <div class=animation _v-0fc6258c=\"\"> <sprite :images=images :playing=!loaded _v-0fc6258c=\"\"></sprite> </div> </div> ";

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	module.exports = " <li v-link=\"{ name: 'exercise', params: { id: this.id }}\" class=exercise transition=reveal _v-1a8c0ede=\"\"> {{title}} </li> ";

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	module.exports = " <div class=input-group _v-1f61a8ce=\"\"> <label _v-1f61a8ce=\"\">{{label}}</label> <slot _v-1f61a8ce=\"\"></slot> </div> ";

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	module.exports = " <div class=team _v-28676324=\"\"> <header-group :heading=team.name subheading=\"Oversigt over holdet\" _v-28676324=\"\"></header-group> <p class=text _v-28676324=\"\">{{{team.description}}}</p> <ul _v-28676324=\"\"> <list-item v-for=\"item in items\" size=small :index=$index v-link=item.link _v-28676324=\"\"> {{item.title}} </list-item> </ul> </div> ";

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	module.exports = " <div class=component-avatar _v-33e4b85c=\"\"> <div class=avatar _v-33e4b85c=\"\"> <img :src=src alt=\"\" title=\"\" _v-33e4b85c=\"\"> </div> </div> ";

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	module.exports = " <div class=login _v-345cf4a8=\"\"> <container _v-345cf4a8=\"\"> <hgroup _v-345cf4a8=\"\"> <h1 _v-345cf4a8=\"\">Log ind</h1> <h3 class=color-tint _v-345cf4a8=\"\">Udfyld felterne herunder</h3> </hgroup> <input-group label=Brugernavn _v-345cf4a8=\"\"> <input type=email v-model=username placeholder=\"E.g. john@doe.dk\" spellcheck=false v-on:keyup.enter=click name=email autocomplete=on _v-345cf4a8=\"\"> </input-group> <input-group label=Adgangskode _v-345cf4a8=\"\"> <input type=password v-model=password placeholder=Adgangskode spellcheck=false v-on:keyup.enter=click name=password autocomplete=on _v-345cf4a8=\"\"> </input-group> <button @click=click _v-345cf4a8=\"\">Log ind</button> </container> </div> ";

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	module.exports = " <div class=component-top _v-382780ac=\"\"> <div class=component-top-container _v-382780ac=\"\"> <div class=\"item item-brand\" _v-382780ac=\"\"> <img class=mindsocial-logo src=https://mindsocial.dk/wp-content/uploads/2019/10/MindSocial-logo-icon-dark-blue.png _v-382780ac=\"\"> <back-button v-if=!isRoot @click=back _v-382780ac=\"\">Back</back-button> </div> <div class=\"item item-main\" _v-382780ac=\"\"> <small-heading _v-382780ac=\"\">{{title}}</small-heading> </div> <div class=\"item item-right\" _v-382780ac=\"\"> </div> </div> </div> ";

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	module.exports = " <div class=container :class=classes _v-3972ea98=\"\"> <slot _v-3972ea98=\"\"></slot> </div> ";

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	module.exports = " <div class=btn :class=buttonClass :data-direction=direction _v-3a4b54f8=\"\"> <div class=btn-back _v-3a4b54f8=\"\"> <p _v-3a4b54f8=\"\">Are you sure you want to do that?</p> <button class=yes @click=confirm _v-3a4b54f8=\"\">Yes</button> <button class=no @click=hide _v-3a4b54f8=\"\">No</button> </div> <div class=btn-front @click=click _v-3a4b54f8=\"\">Delete</div> </div> ";

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	module.exports = " <div class=subexercise _v-3ac7ed48=\"\"> <h1 v-if=loaded _v-3ac7ed48=\"\">{{exercise.title}} {{subid + 1}}</h1> <subexercise v-if=loaded :exercise=subexercise :index=subid _v-3ac7ed48=\"\"> </subexercise> </div> ";

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	module.exports = " <div class=vimeo _v-4431125b=\"\"> <div :id=elementId v-el:wrapper=\"\" _v-4431125b=\"\"></div> </div> ";

/***/ }),
/* 758 */
/***/ (function(module, exports) {

	module.exports = " <path :d=set(data) :stroke-width=strokeWidth :stroke=stroke _v-4fd6712d=\"\"></path> ";

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	module.exports = " <div class=dashboard _v-55a076d3=\"\"> <container align=center _v-55a076d3=\"\"> <ul _v-55a076d3=\"\"> <list-item v-for=\"item in filteredItems\" :index=$index :link=item.link _v-55a076d3=\"\"> {{item.title}} </list-item> <list-item @click=logout _v-55a076d3=\"\"> Log ud </list-item> </ul> <div class=background-layer _v-55a076d3=\"\"> <div class=animation _v-55a076d3=\"\"> <sprite :images=images _v-55a076d3=\"\"></sprite> </div> <p _v-55a076d3=\"\">Oplever du problemer? Kontakt <a class=color-tint href=mailto:support@mindsocial.dk _v-55a076d3=\"\">support@mindsocial.dk</a></p> </div> </container> </div> ";

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	module.exports = " <div class=list _v-588d5c74=\"\"> <div class=items _v-588d5c74=\"\"> <container _v-588d5c74=\"\"> <row justify-content=center _v-588d5c74=\"\"> <column :size=24 _v-588d5c74=\"\"> <slot _v-588d5c74=\"\"></slot> </column> </row> </container> </div> </div> ";

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	module.exports = " <div class=sprite _v-59614f3e=\"\"> <canvas v-el:canvas=\"\" _v-59614f3e=\"\"></canvas> </div> ";

/***/ }),
/* 762 */
/***/ (function(module, exports) {

	module.exports = " <svg class=graph width=100% :height=height _v-5a9def36=\"\"> <g transform=\"\" _v-5a9def36=\"\"> <axis orientation=bottom :scale=scaleX :tick-size-inner=height :ticks=max :opacity=0.1 padded-index=\"\" _v-5a9def36=\"\"></axis> <axis orientation=left :scale=scaleY :tick-size-inner=intWidth :offset-x=intWidth :opacity=0.1 _v-5a9def36=\"\"></axis> <line v-if=pre :scale-x=scaleX :scale-y=scaleY key-y=answer :data=pre stroke=#ccc _v-5a9def36=\"\"></line> <line v-if=post :scale-x=scaleX :scale-y=scaleY key-y=answer :data=post stroke=#ff5216 :stroke-width=3 _v-5a9def36=\"\"></line> </g> </svg> ";

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"button pointer-hover\" transition=reveal _v-5c9188f2=\"\"> <symbol name=arrow-back-left _v-5c9188f2=\"\"></symbol> </div> ";

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	module.exports = " <div class=row :class=classes _v-6284a29e=\"\"> <slot _v-6284a29e=\"\"></slot> </div> ";

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	module.exports = " <div class=vertical-graph _v-641cd68f=\"\"> <div class=question v-for=\"entry in questionsSource\" _v-641cd68f=\"\"> <p _v-641cd68f=\"\"> <strong _v-641cd68f=\"\">{{$index + 1}}: {{entry.question}}</strong> </p> <div class=\"legend horisontal\" _v-641cd68f=\"\"> <div class=entry v-if=\"pre &amp;&amp; $index < pre.length\" _v-641cd68f=\"\"> <p _v-641cd68f=\"\"> Før: {{pre[$index].answer}} </p> <bar :size=pre[$index].answer :scala=pre[$index].scala faded=\"\" _v-641cd68f=\"\"></bar> </div> <div class=entry v-if=\"post &amp;&amp; $index < post.length\" _v-641cd68f=\"\"> <p _v-641cd68f=\"\"> Efter: {{post[$index].answer}} </p> <bar :size=post[$index].answer :scala=post[$index].scala _v-641cd68f=\"\"></bar> </div> </div> </div> </div> ";

/***/ }),
/* 766 */
/***/ (function(module, exports) {

	module.exports = " <div class=bar :class=classes _v-682fac6a=\"\"> <div class=meter :style=style _v-682fac6a=\"\"></div> </div> ";

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	module.exports = " <div class=view _v-68fbed9c=\"\"> <hgroup _v-68fbed9c=\"\"> <h1 _v-68fbed9c=\"\">Nyt hold</h1> <h3 class=color-tint _v-68fbed9c=\"\">Udfyld felterne herunder</h3> </hgroup> <validator name=validation _v-68fbed9c=\"\"> <form novalidate=\"\" :class=classes _v-68fbed9c=\"\"> <div class=field _v-68fbed9c=\"\"> <label for=team-name _v-68fbed9c=\"\">Holdnavn</label> <input type=text v-model=name v-validate:name=\"{ minlength: 3, required: true }\" id=team-name _v-68fbed9c=\"\"> </div> <div class=field _v-68fbed9c=\"\"> <label for=team-description _v-68fbed9c=\"\">Beskrivelse</label> <textarea v-model=description id=team-description _v-68fbed9c=\"\"></textarea> </div> <div class=field v-if=predefined _v-68fbed9c=\"\"> <h2 _v-68fbed9c=\"\">Prædefinerede træningsprogrammer</h2> <p _v-68fbed9c=\"\">Du kan vælge at tage udgangspunkt i følgende træningsprogrammer</p> <div class=\"input-group input-group-radio\" _v-68fbed9c=\"\"> <div class=input _v-68fbed9c=\"\"> <input type=radio name=predefinedType v-model=predefinedType value=none checked=\"\" _v-68fbed9c=\"\"> <label for=predefinedType _v-68fbed9c=\"\">Ingen</label> </div> <div class=input v-for=\"item in predefined\" _v-68fbed9c=\"\"> <input type=radio name=predefinedType v-model=predefinedType :value=item.id _v-68fbed9c=\"\"> <label for=predefinedType _v-68fbed9c=\"\">{{item.title}}</label> </div> </div> </div> <div class=field _v-68fbed9c=\"\"> <validator name=attendee _v-68fbed9c=\"\"> <div class=input-group _v-68fbed9c=\"\"> <div class=field _v-68fbed9c=\"\"> <label for=attendee-name _v-68fbed9c=\"\">Deltager</label> <input v-model=attendee v-validate:attendee=\"{ required: true }\" v-on:keyup.enter=addAttendee type=text id=attendee-name _v-68fbed9c=\"\"> </div> <div class=field _v-68fbed9c=\"\"> <label for=attendee-mail _v-68fbed9c=\"\">Mail</label> <input v-model=mail v-validate:mail=\"['required', 'email']\" v-on:keyup.enter=addAttendee type=text id=attendee-mail _v-68fbed9c=\"\"> </div> <div class=field _v-68fbed9c=\"\"> <label for=attendee-survey-type _v-68fbed9c=\"\">Evaluering</label> <select v-model=survey_type v-on:keyup.enter=addAttendee id=attendee-survey-type _v-68fbed9c=\"\"> <option value=\"\" _v-68fbed9c=\"\">-- ingen --</option> <option v-for=\"(key, label) in surveyTypes\" :value=key _v-68fbed9c=\"\">{{label}}</option> </select> </div> </div> <div class=button v-if=$attendee.valid @click=addAttendee _v-68fbed9c=\"\">Tilføj deltager</div> </validator> <table-data :data=attendeesDisplay :columns=tableColumns @remove=onRemove _v-68fbed9c=\"\"> </table-data> </div></form> <div class=errors _v-68fbed9c=\"\"> <p v-if=$validation.name.required _v-68fbed9c=\"\">Udfyld holdnavn.</p> <p v-if=$validation.name.minlength _v-68fbed9c=\"\">Holdnavn skal være på minimum tre karakterer.</p> </div> <button type=button class=button v-if=$validation.valid @click=submit _v-68fbed9c=\"\">Tilføj hold</button> </validator> </div> ";

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	module.exports = " <div class=difficulties _v-6ff4fb52=\"\"> <template v-for=\"difficulty in sortedDifficulties\"> <div class=difficulty _v-6ff4fb52=\"\"> <h3 _v-6ff4fb52=\"\">{{difficulty.name}}</h3> <div class=meter :class=getMeterClasses(difficulty) _v-6ff4fb52=\"\"> <div class=progress _v-6ff4fb52=\"\"></div> </div> </div> </template> </div> ";

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	module.exports = " <hgroup _v-736b2dc9=\"\"> <h1 _v-736b2dc9=\"\">{{heading}}</h1> <h2 v-if=heading2 _v-736b2dc9=\"\">{{heading2}}</h2> <h3 v-if=subheading class=color-tint _v-736b2dc9=\"\">{{subheading}}</h3> </hgroup> ";

/***/ }),
/* 770 */
/***/ (function(module, exports) {

	module.exports = " <div class=view-exercises _v-7f7bfd9f=\"\"> <list-layout _v-7f7bfd9f=\"\"> <filters :filters=filters @filter=setFilter v-if=filtersVisible _v-7f7bfd9f=\"\"></filters> <ul _v-7f7bfd9f=\"\"> <list-item size=small v-for=\"e in filteredExercises\" :index=$index :order=e.order :link=getListItemLink(e.id) _v-7f7bfd9f=\"\"> {{e.title}} </list-item> </ul> </list-layout> </div> ";

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	module.exports = " <table class=\"table table-striped\" _v-842c79a2=\"\"> <thead _v-842c79a2=\"\"> <tr _v-842c79a2=\"\"> <th v-for=\"column in columns\" @click=sortBy(column.key) :class=\"{active: sortKey == column.key}\" _v-842c79a2=\"\"> {{column.name}} <span class=arrow v-if=column.sort :class=\"sortOrders[column.key] > 0 ? 'asc' : 'dsc'\" _v-842c79a2=\"\"> </span> </th> <th _v-842c79a2=\"\">Fjern</th> </tr> </thead> <tbody _v-842c79a2=\"\"> <tr v-for=\"\n      entry in data\n      | filterBy filterKey\n      | orderBy sortKey sortOrders[sortKey]\" _v-842c79a2=\"\"> <td v-for=\"column in columns\" _v-842c79a2=\"\"> {{entry[column.key]}} </td> <td _v-842c79a2=\"\"> <div class=\"button-small pointer-hover\" @click=onClick($index) _v-842c79a2=\"\">Fjern</div> </td> </tr> </tbody> </table> ";

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"small-logo pointer-hover\" v-on:mouseover=mouseOver v-on:mouseleave=mouseLeave transition=logo _v-9a287e2e=\"\"> <canvas _v-9a287e2e=\"\"></canvas> </div> ";

/***/ }),
/* 773 */
/***/ (function(module, exports) {

	module.exports = " <article class=subexercise _v-ba5269e2=\"\"> <h1 _v-ba5269e2=\"\">{{index + 1}}</h1> <h4 _v-ba5269e2=\"\">Sværhedsgrad</h4> <difficulties :difficulties=exercise.difficulties _v-ba5269e2=\"\"></difficulties> <h4 v-if=exercise.description _v-ba5269e2=\"\">Beskrivelse</h4> <p _v-ba5269e2=\"\">{{{exercise.description}}}</p> <h4 v-if=exercise.execution _v-ba5269e2=\"\">Trin</h4> <p _v-ba5269e2=\"\">{{{exercise.execution}}}</p> <h4 v-if=exercise.input _v-ba5269e2=\"\">Input</h4> <p _v-ba5269e2=\"\">{{{exercise.input}}}</p> <h4 v-if=exercise.remarks _v-ba5269e2=\"\">Bemærkninger</h4> <p _v-ba5269e2=\"\">{{{exercise.remarks}}}</p> </article> ";

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	module.exports = " <div class=view _v-cc3e5aaa=\"\"> <container _v-cc3e5aaa=\"\"> <header-group heading=Evaluering subheading=\"Her kan du se hvordan det går med dine deltagere\" _v-cc3e5aaa=\"\"> </header-group> <h2 _v-cc3e5aaa=\"\">Udsend evalueringsskemaer</h2> <div class=send-survey _v-cc3e5aaa=\"\"> <table class=\"table table-striped\" _v-cc3e5aaa=\"\"> <thead _v-cc3e5aaa=\"\"> <tr _v-cc3e5aaa=\"\"> <th _v-cc3e5aaa=\"\">#</th> <th _v-cc3e5aaa=\"\">Navn</th> <th _v-cc3e5aaa=\"\">Evaluering</th> <th _v-cc3e5aaa=\"\">Udsend evalueringsskemaer</th> <th _v-cc3e5aaa=\"\">Resultater</th> </tr> </thead> <tbody _v-cc3e5aaa=\"\"> <tr v-for=\"attendee in attendees\" _v-cc3e5aaa=\"\"> <td _v-cc3e5aaa=\"\">{{attendee.id}}</td> <td _v-cc3e5aaa=\"\">{{attendee.name}}</td> <td _v-cc3e5aaa=\"\">{{surveyTypeDisplay(attendee)}}</td> <td _v-cc3e5aaa=\"\"> <div v-if=\"sending === attendee.id\" class=sending-message _v-cc3e5aaa=\"\">Sender. Luk ikke for vinduet</div> <div v-else=\"\" _v-cc3e5aaa=\"\"> <button class=narrow @click=\"sendSurvey('pre', attendee.id)\" v-if=\"allowSendEvaluation(attendee, 'pre')\" :disabled=\"surveyAlreadyAnswered(attendee, 'pre')\" _v-cc3e5aaa=\"\">Før</button> <button class=narrow @click=\"sendSurvey('post', attendee.id)\" v-if=\"allowSendEvaluation(attendee, 'post')\" :disabled=\"surveyAlreadyAnswered(attendee, 'post')\" _v-cc3e5aaa=\"\">Efter</button> <button class=narrow @click=\"sendSurvey('sharp_brains', attendee.id)\" v-if=\"allowSendEvaluation(attendee, 'sharp_brains')\" :disabled=\"surveyAlreadyAnswered(attendee, 'sharp_brains')\" _v-cc3e5aaa=\"\">Efter</button> </div> </td> <td _v-cc3e5aaa=\"\"> <span v-if=\"attendee.survey_type !== ''\" class=attendee-results-button :class=setClasses(attendee.id) @click=setIndex(attendee.id) _v-cc3e5aaa=\"\">Se resultater</span> </td> </tr> </tbody> </table> </div> <div v-if=preComment _v-cc3e5aaa=\"\"> <strong _v-cc3e5aaa=\"\">Kommentar før:</strong> <p _v-cc3e5aaa=\"\">{{preComment}}</p> </div> <div v-if=postComment _v-cc3e5aaa=\"\"> <strong _v-cc3e5aaa=\"\">Kommentar efter:</strong> <p _v-cc3e5aaa=\"\">{{postComment}}</p> </div> <vertical-graph :pre=preAnswers :post=postAnswers v-if=\"preAnswers || postAnswers\" _v-cc3e5aaa=\"\"></vertical-graph> </container> </div> ";

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	module.exports = " <li v-link=link :class=classes _v-d56219ec=\"\"> <slot _v-d56219ec=\"\"></slot> </li> ";

/***/ }),
/* 776 */
/***/ (function(module, exports) {

	module.exports = " <ul class=filters _v-dace2e5c=\"\"> <li :class=\"{'active': !filter}\" @click=setFilter(null) _v-dace2e5c=\"\">Alle</li> <li v-for=\"_filter in sortedFilters\" :class=\"{'active': _filter === filter}\" @click=setFilter(_filter) _v-dace2e5c=\"\"> {{_filter}} </li> </ul> ";

/***/ }),
/* 777 */
/***/ (function(module, exports) {

	module.exports = " <div class=view _v-dd2dbf16=\"\"> <container _v-dd2dbf16=\"\"> <h2 class=\"color-tint pointer-hover\" v-link=\"{name: 'new-team'}\" _v-dd2dbf16=\"\">+ Tilføj hold</h2> <p _v-dd2dbf16=\"\">Når du har oprettet et hold kan det ikke slettes igen. Dette er et sikkerhedshensyn så hold ikke mistes ved fejl, hvis der er flere brugere på samme login. Du kan sende en mail til <a class=color-tint href=mailto:support@mindsocial.dk _v-dd2dbf16=\"\">support@mindsocial.dk</a> og bede os fjerne holdet fra listen. </p> <ul _v-dd2dbf16=\"\"> <template v-for=\"team in teams\"> <list-item v-link=\"{name: 'team', params: {team: team.id}}\" _v-dd2dbf16=\"\"> {{team.name}} </list-item> </template> </ul> </container> </div> ";

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	module.exports = " <h4 class=small-heading _v-e68c6098=\"\"> <slot _v-e68c6098=\"\"></slot> </h4> ";

/***/ }),
/* 779 */
/***/ (function(module, exports) {

	module.exports = " <div class=view _v-eccbcfa4=\"\"> <header class=top _v-eccbcfa4=\"\"> <h2 class=\"color-tint pointer-hover\" @click=addSession _v-eccbcfa4=\"\">+ Tilføj session</h2> <p class=to-bottom @click=scrollToBottom _v-eccbcfa4=\"\">Gå til bund</p> </header> <template v-if=sessions> <div class=column v-el:sessions=\"\" _v-eccbcfa4=\"\"> <div class=inner _v-eccbcfa4=\"\"> <template v-if=\"sessions.length === 0\"> <h3 _v-eccbcfa4=\"\">Ingen aktive sessions</h3> </template> <ul class=list v-if=\"sessions.length > 0 &amp;&amp; allExercises.length > 0\" _v-eccbcfa4=\"\"> <li v-for=\"session in sessions\" class=list-item _v-eccbcfa4=\"\"> <header _v-eccbcfa4=\"\"> <h3 _v-eccbcfa4=\"\">Session {{$index + 1}}</h3> <span @click=deleteSession($index) _v-eccbcfa4=\"\">Fjern</span> </header> <ul class=horisontal v-sortable=sortableOptions :data-session=$index _v-eccbcfa4=\"\"> <li v-for=\"exercise in session.exercises\" :class=exercise.status :data-session=$parent.$index :data-id=exercise.id :data-sub-id=exercise.subId _v-eccbcfa4=\"\"> <span class=status :class=exercise.status @click=toggleStatus(exercise) _v-eccbcfa4=\"\"></span> <span v-link=\"{name: 'subexercise', params: {id: exercise.id, subid: parseInt(exercise.subId)}}\" _v-eccbcfa4=\"\">{{getExercise(exercise.id).title}}</span> <span class=index _v-eccbcfa4=\"\">{{parseInt(exercise.subId) + 1 }}</span> <span class=index @click=\"removeExercise($index, $parent.$index)\" _v-eccbcfa4=\"\">x</span> </li> </ul> </li> </ul> </div> </div> <div class=\"column column-exercises\" v-if=allExercises _v-eccbcfa4=\"\"> <div class=inner _v-eccbcfa4=\"\"> <h2 _v-eccbcfa4=\"\">Øvelser</h2> <filters :filters=filters @filter=setFilter _v-eccbcfa4=\"\"></filters> <ul class=list _v-eccbcfa4=\"\"> <li class=list-item v-for=\"exercise in filteredExercises\" _v-eccbcfa4=\"\"> <h3 v-link=\"{name: 'exercise', params: {id: exercise.id}}\" _v-eccbcfa4=\"\">{{exercise.title}}</h3> <ul class=horisontal v-sortable=sortableExercisesOptions _v-eccbcfa4=\"\"> <li class=outline v-for=\"subexercise in exercise.exercises\" :data-id=exercise.id :data-sub-id=subexercise.id data-remove=true _v-eccbcfa4=\"\"> {{$index + 1}} </li> </ul> </li> </ul> </div> </div> </template> </div> ";

/***/ }),
/* 780 */
/***/ (function(module, exports) {

	module.exports = " <div class=column :class=classes _v-fed32162=\"\"> <slot _v-fed32162=\"\"></slot> </div> ";

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(675)
	__vue_script__ = __webpack_require__(366)
	__vue_template__ = __webpack_require__(737)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(690)
	__vue_script__ = __webpack_require__(367)
	__vue_template__ = __webpack_require__(751)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(676)
	__vue_script__ = __webpack_require__(368)
	__vue_template__ = __webpack_require__(738)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(702)
	__vue_script__ = __webpack_require__(369)
	__vue_template__ = __webpack_require__(763)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(707)
	__vue_script__ = __webpack_require__(373)
	__vue_template__ = __webpack_require__(768)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(687)
	__vue_script__ = __webpack_require__(374)
	__vue_template__ = __webpack_require__(748)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(701)
	__vue_script__ = __webpack_require__(377)
	__vue_template__ = __webpack_require__(762)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(677)
	__vue_script__ = __webpack_require__(378)
	__vue_template__ = __webpack_require__(739)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(688)
	__vue_script__ = __webpack_require__(380)
	__vue_template__ = __webpack_require__(749)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(697)
	__vue_script__ = __webpack_require__(381)
	__vue_template__ = __webpack_require__(758)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(717)
	__vue_script__ = __webpack_require__(385)
	__vue_template__ = __webpack_require__(778)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(711)
	__vue_script__ = __webpack_require__(386)
	__vue_template__ = __webpack_require__(772)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(681)
	__vue_script__ = __webpack_require__(390)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(679)
	__vue_script__ = __webpack_require__(392)
	__vue_template__ = __webpack_require__(741)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(692)
	__vue_script__ = __webpack_require__(393)
	__vue_template__ = __webpack_require__(753)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(704)
	__vue_script__ = __webpack_require__(394)
	__vue_template__ = __webpack_require__(765)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(680)
	__vue_script__ = __webpack_require__(395)
	__vue_template__ = __webpack_require__(742)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(696)
	__vue_script__ = __webpack_require__(396)
	__vue_template__ = __webpack_require__(757)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(699)
	__vue_script__ = __webpack_require__(397)
	__vue_template__ = __webpack_require__(760)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(698)
	__vue_script__ = __webpack_require__(398)
	__vue_template__ = __webpack_require__(759)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(682)
	__vue_script__ = __webpack_require__(399)
	__vue_template__ = __webpack_require__(743)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(709)
	__vue_script__ = __webpack_require__(400)
	__vue_template__ = __webpack_require__(770)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(691)
	__vue_script__ = __webpack_require__(401)
	__vue_template__ = __webpack_require__(752)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(706)
	__vue_script__ = __webpack_require__(402)
	__vue_template__ = __webpack_require__(767)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(683)
	__vue_script__ = __webpack_require__(403)
	__vue_template__ = __webpack_require__(744)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(685)
	__vue_script__ = __webpack_require__(404)
	__vue_template__ = __webpack_require__(746)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(684)
	__vue_script__ = __webpack_require__(405)
	__vue_template__ = __webpack_require__(745)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(718)
	__vue_script__ = __webpack_require__(406)
	__vue_template__ = __webpack_require__(779)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(695)
	__vue_script__ = __webpack_require__(407)
	__vue_template__ = __webpack_require__(756)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(713)
	__vue_script__ = __webpack_require__(408)
	__vue_template__ = __webpack_require__(774)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(689)
	__vue_script__ = __webpack_require__(409)
	__vue_template__ = __webpack_require__(750)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(716)
	__vue_script__ = __webpack_require__(410)
	__vue_template__ = __webpack_require__(777)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.21068cc6c2092b9e7198.js